import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewContainerRef,ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray,FormControl,RequiredValidator } from '@angular/forms';
import { GlobalService } from 'app/_service/global.service';
import { IssuepolicyService } from 'app/_service/issuepolicy.service';
import { SmequoteService } from 'app/_service/smequote.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { MotorquoteService } from 'app/_service/motorquote.service';
import { HomequoteService } from 'app/_service/homequote.service';
import { TraveInsuranceService } from 'app/_service/traveInsurance.service';
import { GeoLocationComponent } from '../geo-location-modal/geo-location.component';
import { googleMapService } from 'app/_service/google-map-service';
import { config } from 'app/config';
import { of, ReplaySubject, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil ,startWith} from 'rxjs/operators'
import { ChangeDetectorRef } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-smecpm',
  templateUrl: './smecpm.component.html',
  styleUrls: ['./smecpm.component.scss']
})

export class SmecpmComponent implements OnInit {
    characterToReplace = '&';
    replacementCharacter = '&#38;';
    optionyesNo = [{
        value: 'Y',
        label: 'Yes'
    }, {
        value: 'N',
        label: 'No'
    }, ]
    coverage: any[] = [];
    annualWageList: any[] = [];
    uwNames: any[] = [];
    conditionType = [{
            id: 1,
            value: 'Exclusions',

        },
        {
            id: 2,
            value: 'Warranties',

        },
        {
            id: 3,
            value: 'Condition',

        },

    ]
    conditions = [{
        conditionType: '',
        description: '',
        productCode: ''
    }];

    smeQuoteDetails: FormGroup;
    localStorDta: any;
    partnerID: any;
    noofFloor: any;
    turnOver: any;
    natureofwork: any;
    claimHistory: any;
    emirates: any;
    emiratesArea: any;
    conclass: any;
    indSegment: any;
    busseg: any = [];
    emrmall: any = [];
    bussPremise: any;
    userId: any;
    validtnMsg: boolean;
    formDataRes: any;
    partnersArr: any;
    partnerId: any;
    partnerVal: number = 0;
    partnerBranchArr: any[];
    accept_terms: boolean = false;
    accept_disclaimer: boolean = false;
    branchId: any;
    branchVal: any;
    quoteNumber = '';
    benefitData: any;
    WorkmensName = "Workmens Compensation including Employers Liability "
    Property: any;
    rowAmount: number = 0;
    sectionpremium_CAR: number[] = [];
    sectionpremium_Money: number[] = [];
    sectionpremium_PL: number[] = [];
    totalsumCoveredAll: number = 0;
    quoteProceed: boolean = true;
    IntitatedPolicyResult: any[] = [];
    IsRenewal: number;
    productId: any;
    options: any[] = [];
    BusinessEntityList: any;
    filteredOptions: any = [];
    filteredOptionsList: any[] = [];
    matchedEnitity: any;
    IsSameBusiness: boolean = false;
    approveButton: boolean = false;
    docListpol: any[] = [];
    isConditionModelOpen: boolean = false;
    IIRISCodes: any[] = [];
    RefAssignedUserName: string;
    quoteConditions: any;
    event: any;
    byPassOnAccountCheck: boolean = false;
    locationSumInsured: number;
    locationPremium: number;
    totalsectionBasePremium: any;
    typeofwork: any[] = [];
    typeofWorkSegment: any;
    insuredAmount = [];
    totalPremium: number = 0;
    policyFee = 50;
    basePremium: number[] = [];
    Vat_Amount: number = 0;
    totalbasepremium: number = 0
    totalsumCovered: number[] = [];
    loadingby: any;
    discountby: any
    loadingAmount: number = 0;
    discountAmount: number = 0;
    planId: any;
    serviceTax: any;
    freezzone: any;
    ButtonName = "Get Quote"
    policyType = "NEW";
    quoteId: any;
    businessSegmentLoader: boolean;
    emiratesmallLoader: boolean;
    quoteLoader: boolean;
    pageLoader: boolean;
    processType = "'INSERT'"
    policyNumber: any;
    productCode: string;
    companydocument: any;
    documentCheckbox: boolean = false;
    docList: any[][] = [];
    docUploadFlag: boolean = false;
    minDate = new Date(Date.now());
    maxDate = new Date(new Date().setDate(new Date().getDate() + 30));
    renewalmaxdate = new Date(new Date().setDate(new Date().getDate() + 45)); // we must not take todays date , it must be policy expiry date + 60 days ; - check with business
    madFileds: string;
    quotationloader: boolean;
    refquotationloader: boolean;
    issuepolicyLoader: boolean;
    worDoc: any;
    userAccess: boolean = true;
    referalModel: boolean = false;
    businessPackageModel: boolean = false;
    uploadAddinfoDocumentinScreen: boolean = false
    refer_type: string;
    refer_condtion_type: number;
    referalDescription: string = '';
    referal: boolean;
    policyStatus: string;
    validtnMsgfordescription: boolean;
    additionalDoc: boolean;
    additionalDocFile: any[];
    document_data: any;
    hideImages: boolean;
    tempAdditionalDoc: any[];
    refferalButton: boolean = false;
    businessSource: any;
    accessGroup: any;
    userRole: any;
    userType: any;
    checkId: any;
    quoteStatus: any;
    quotationHistoryArr: any;
    emailAdd: any = '';
    minLoadingRange: any = 0;
    maxLoadingRange: any;
    creditLimit: any;
    PTY_CREDIT_LMT_DAYS: any;
    lmt_days: boolean = false;
    source = 'B2B';
    emiId: any;
    partnerActive: boolean = false; //Added by Anju for partnercreditlimitcheck
    selectedPartnerId: any; //added by Anju for Partner Credit Limit check
    selectedBranchId: any; //added by Anju for Partner Credit Limit check
    checkcreditLimitArray: any = [];
    chechfor: boolean = true;
    emailaddValidation: boolean = false;
    access: number;
    disabled: boolean = false;
    disabledbr: boolean = false;
    reapprove: boolean = false;
    disableDate: boolean = false;
    planData: any;
    allowed: number = 1;
    public showLoader = {
        load_data: false, // added loader for initial page loading - ruhina
    };
    selectedYear: number;
    years: number[] = [];
    TotalCont: any;
    ValueAddedT: any;
    PremiumLoad: any;
    LoadingRate: any;
    PremiumDisc: any;
    DiscountRate: any;
    cv: number[] = [];
    pesp: number[] = [];
    cpm: number[] = [];
    uv: number[] = [];
    tf: number[] = [];
    dr: number[] = [];
    totalcar: number[] = [];
    Icw: number[] = [];
    grssp: number[] = [];
    totalBI: number[] = [];
    totalparpr: number[] = [];
    totalparpl: number[] = [];
    totalplwc: number[] = [];
    totalwcpar: number[] = [];
    expiryDate: any;
    dtminDate: Date;
    dtmaxDate: Date;
    PubLty: number[] = [];
    ratioallowed: number = 0;
    upliftref: number = 0;
    cvref: number = 0;
    pespref: number = 0;
    cpmref: number = 0;
    tfref: number = 0;
    drref: number = 0;
    userID: any;
    userBranchArr: any[];


    totalsalary: any;
    madFiledsBuilding: string = "*";
    quotation_branchId: string = "";
    is_buildingSelected: boolean[] = [];
    refReason: any[] = [];
    referalRes: any;
    isReferral: any;
    file_name: any;
    UploadedFileName: any;
    response_code: any;
    quoteDocumentsList: any[] = [];
    showWC: boolean;
    buttonds: boolean;
    ref_value: any;
    claimCount: any;
    claimAmount: any;
    claimRatio: number;
    expiringPremium: any;
    valueRatio: number;
    addressLocationCords: string = "";
    geoLocationMandatory: boolean = true;
    riskInMall: boolean[] = [false];
    WCMandatory: any[] = [];
    InitiatedQuote: boolean = false;
    initiatedPolDocs: any = [];
    enableCoverStartDateModify: boolean = false;
    private digi_status = new Subject < string > ();
    digi_status$ = this.digi_status.asObservable();
    digiSwalInstance: any;
    @ViewChild('modalContainer', {
        static: true,
        read: ViewContainerRef
    }) modalContainer: ViewContainerRef;
    showIcon: boolean;
    isDirectSalesAgent: boolean;
    otherFileName: any;
    claimFileName: any;
    claimResponseCode: string;
    uploadedClaimFileName: any;
    otherResponseCode: string;
    uploadedOtherFileName: any;
    additionalDocFiles: Array < {
        fileName: string,
        fileType: string,
        fileURL: string
    } > = [];
    bankDetail: any;
    RefAssignedTo: string;
    totalSumInsured: any = [];
    bankDetailres: any;
    allowedLimit: number[] = [];
    isToBeReferred: boolean = false;
    filteredquotationHistoryArr: any;
    adminCount: number[] = []; // Track number of Admin employees
    nonAdminCount: number[] = []; // Track number of Non-admin employees
    adminSumInsured: number[] = []; // Calculate the sum insured for Admin
    nonAdminSumInsured: number[] = []; // Calculate the sum insured for Non-admin
    totalSumInsured1: number[] = []; // Calculate the total sum insured
    totalEmployees: number[] = []; // Calculate the total sum insured
    EmployeeHeaderData: any;
    locationFormArray: any = [];
    itemDeclartion: any = [];
    locationForm: FormGroup;
    additionalDetailForm: FormGroup
    currentSubArray: any = [];
    currentIndex: number = 0;
    brokerCommissionPercentage: number = 25;
    legalStatus: any[] = [];
    equipmentTypeList : any
    errorMessages: string[] = [];
    constructor(public _route: Router, public formBuilder: FormBuilder, public homeQuoteService: HomequoteService, public _activatedroute: ActivatedRoute, public smequoteService: SmequoteService, public issuepolicyService: IssuepolicyService, public motorQuoteService: MotorquoteService, public globalService: GlobalService, public travelInsuranceService: TraveInsuranceService, private resolver: ComponentFactoryResolver, private _googleMapService: googleMapService, private cdr: ChangeDetectorRef) {

        this.smeQuoteDetails = this.formBuilder.group({
            partner: ['', Validators.required],
            branch: ['', Validators.required],
            businessName: ['', Validators.compose([Validators.required, Validators.pattern(/^[a-zA-Z0-9\s!@#$%^&.,-/()*]+$/)])],
            claimHistory: ['', Validators.required], //Pol

        });

        this.locationForm = this.formBuilder.group({
            locations: this.formBuilder.array([])
        })
        this.additionalDetailForm = this.formBuilder.group({
            BusinessEntityName: [this.smeQuoteDetails.value.businessName, Validators.required],
            CoverStartDate: [this.minDate, Validators.required],
            vatRegcheck: ['', Validators.required],
            legalstatus: ['', Validators.required],
            additionalDetails: this.formBuilder.array([])
        })

    }

    async ngOnInit() {


        console.log(this.conditions)
        console.log(this.additionalDetails.controls)
        console.log(this.locationForm)
        const routParam = this._activatedroute.snapshot.params;
        if (routParam.productid == 'SMECPM') {
            this.productId = routParam.productid
            this.productCode = 'SMECPM';
        }
          if (routParam.productid == 'SMEEAR') {
            this.productId = routParam.productid
            this.productCode = 'SMEEAR';
        }

        this.addLocation();

        if (routParam.quoteNumber && routParam.ID == "3") {
            this.InitiatedQuote = true;
            this.localStorDta = this.globalService.getLocalStorageData();
            this.userID = Number(this.localStorDta.User_ID);
            let privilagedUsers: number[] = config.sme_EnableCoverDateEdit.split(',').map(Number);
            if (privilagedUsers.includes(this.userID)) {
                this.enableCoverStartDateModify = true;
                const today = new Date();
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - 30);
                this.minDate = thirtyDaysAgo;

            }
        }
        this._googleMapService.getLocation().subscribe(res => {
            this.addressLocationCords = res;
            this.additionalDetailForm.get('companyAddressGeoLocation').setValue(res);
        })
        this.setupYears();
        this.showLoader.load_data = true;
        this.localStorDta = this.globalService.getLocalStorageData();
        this.partnerID = this.localStorDta.Partner_ID;
        this.userID = this.localStorDta.User_ID;
        this.businessSource = this.localStorDta.BusinessSource;
        this.claimCount = localStorage.getItem('ClaimCount');
        this.claimAmount = localStorage.getItem('ClaimAmount');
        this.expiringPremium = localStorage.getItem('ExpiringPremium');
        console.log(this.claimCount);
        console.log(this.claimAmount);
        this.accessGroup = this.localStorDta.AccessGroup;
        this.userRole = this.localStorDta.UserRole;
        this.userType = this.localStorDta.UserType;
        // this.productCode = localStorage.getItem('ProductCode');

        console.log(this.productCode);
        this.businessSegmentLoader = this.globalService.spinnerHide();
        this.emiratesmallLoader = this.globalService.spinnerHide();
        this.issuepolicyLoader = this.globalService.spinnerHide();
        this.pageLoader = this.globalService.spinnerHide();
        this.quotationloader = this.globalService.spinnerHide();
        this.refquotationloader = this.globalService.spinnerHide();
        this.quoteLoader = this.globalService.spinnerHide();
        this.userId = this.localStorDta.User_ID;


        this.checkUserAccess();
        this.getUWNames();
   
        console.log("PartnerId outside Quotation Form", this.partnerID);
        this.getQuotationFormData();
        this.getEquipmentType();

        this.getfloorCount();
        this.getannualover();
        this.getNatureOfWork();
        this.getConstClass();
        this.getIndSegment();
        this.getBusinessPremise();
        this.getAnnualWages();
        this.getCoverPremises();
        this.getIIRISProductCodes();
        this.getLegalStatus();

 
        this.getemirates();
        this.getcliamhistory();
       

        this.getZone();
        this.getMortgagelist();
        this.issuepolicyService.byPassonAccountCheck('SM').subscribe((res) => {
            this.byPassOnAccountCheck = res.status;
            console.log(this.byPassOnAccountCheck)
        });


        if (this.userRole == 'BROKER' && this.userType == 'POS') {
            if (this.partnerID == 1) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
        if (this.userRole == 'BROKER' || this.userType == 'POS') {
            if (this.partnerID == 1) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
        if (this.partnerID == 1) {
            this.disabledbr = false;
        } else {
            this.disabledbr = true;
        }

        const routeParams = this._activatedroute.snapshot.params;
        console.log(routeParams.quoteNumber)
        if (routeParams.quoteNumber && !routeParams.policyNumber) {
            // alert(1)
            this.pageLoader = this.globalService.spinnerShow();
            setTimeout(() => {
                // this.policyNumber = routeParams.policyNumber;
                this.checkId = routeParams.ID;
                // console.log(this.checkId);
                if (this.checkId != '') {
                    this.quoteNumber = routeParams.quoteNumber;
                    this.ButtonName = "Update Quote";
                    this.policyType = "Update";
                    this.getQuoteDetails();
                }
            }, 1000);


        }
        if (routeParams.policyNumber) {
            this.pageLoader = this.globalService.spinnerShow();
            setTimeout(() => {
                this.policyNumber = routeParams.policyNumber;
                this.ButtonName = "Update Quote";
                this.policyType = "RENEWAL";
                this.quoteNumber = routeParams.quoteNumber;
                this.getQuoteDetails();
            }, 1000);
        }


        //shuhaib initiated policy
        if (this.InitiatedQuote) {
            this.GetInitiatedPolicyDetails(routeParams.quoteNumber);
        }
    
        this.filteredOptions = this.smeQuoteDetails.get('businessName').valueChanges.pipe(
            debounceTime(300), 
            switchMap((searchText: string) => {
                if (searchText.trim().length === 0) {
                    return of([]); // Return an empty array if search text is empty
                }

              
                return this.smequoteService.searchRecords(searchText).pipe(
                    catchError((error) => {
                        console.error('Error occurred during search:', error);
                        return of([]); // Return an empty array in case of an error
                    })
                );
            })
        );
        this.filteredOptions.subscribe((options) => {
            this.filteredOptionsList = options;
        });

        // Subscribe to index 0 value changes after it's created
        this.additionalDetails.at(0).valueChanges.subscribe(val => {
            this.syncAdditionalDetails(val);
        });

    }

 
    get locations(): FormArray {
        return this.locationForm.get('locations') as FormArray;
    }
    get additionalDetails(): FormArray {
        return this.additionalDetailForm.get('additionalDetails') as FormArray;
    }

    // Function to create a new location FormGroup
    createLocation(): FormGroup {
        if (this.productCode == 'SMECPM') {
            return this.formBuilder.group({

                equipmentType: ['', Validators.required],
                equipmentQuantity: ['1'],
                equipmentYear: ['', Validators.required],
                equipmentValue: ['', Validators.required],
                equipmentMake: ['', Validators.required],
                equipmentModel: ['', Validators.required],
                equipmentNo: ['', Validators.required],

            });
        }
        


    }

    // Function to create a new location FormGroup
    createAdditionalDetail(): FormGroup {
        if (this.productCode == 'SMECPM') {
            return this.formBuilder.group({
                contactperson: ['', Validators.required],
                mortgageecheck: [''],

                mortgagee1: [''],
                mortgagee2: [''],
                bankDetails: [''],
                assignmentValue: [''],

                tradeLicNumber: ['', Validators.required],
                companyAddress: ['', Validators.required],
                // companyAddressGeoLocation : ['',Validators.compose([Validators.required,Validators.minLength(8)])],
                companyAddressGeoLocation: [''],
                poboxNo: ['', Validators.required],
                phoneNumber: ['', Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern(/^((02|03|04|06|07|08|09){1}([0-9]{7}))$/)])],


                email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z]+([.-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+([.-]?[a-zA-Z0-9])+)[.]{1}[a-zA-Z]{2,}$')])],
                trnNo: [''],
                mobNo: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^((050|052|054|055|056|057|058|059){1}([0-9]{7}))$/)])],
                freezzone: [''],
            });
        }


    }

    // Function to add a new location to the form array
    addLocation() {
        // if (this.locations.length >= 26) {
        //     Swal.fire("Sorry,Maximum No of Equipments allowed is 25", "error");
        //     return false;
        // }
        this.locations.push(this.createLocation());
       // this.additionalDetails.push(this.createAdditionalDetail());
         // Create a new additional detail
  const newDetail = this.createAdditionalDetail();

  // If index 0 exists, copy its value
  if (this.additionalDetails.length > 0) {
    const firstValue = this.additionalDetails.at(0).value;
    newDetail.patchValue(firstValue, { emitEvent: false });
  }

  this.additionalDetails.push(newDetail);
    }
syncAdditionalDetails(sourceValue: any) {
  for (let i = 1; i < this.additionalDetails.length; i++) {
    this.additionalDetails.at(i).patchValue(sourceValue, { emitEvent: false });
  }
}


    // Function to remove a location from the form array
    removeLocation(index: number) {
        this.locations.removeAt(index);
        this.additionalDetails.removeAt(index);
    }

    get f() {
        return this.smeQuoteDetails.controls;
    }
    getfloorCount() {
        this.smequoteService.getfloorcount(this.partnerID).subscribe(res => {

            this.noofFloor = res.Quotations;

        })
    }

    getUWNames() {
        this.smequoteService.getUWNames(this.partnerID).subscribe(res => {

            this.uwNames = res.Quotations;

        })
    }


    getAnnualWages() {
        this.smequoteService.getAnnualWages(this.partnerID).subscribe(res => {

            this.annualWageList = res.Quotations;

        })
    }

    getCoverPremises() {
        this.smequoteService.getCoverPremises(this.partnerID).subscribe(res => {

            this.coverage = res.Quotations;

        })
    }


    getIIRISProductCodes() {
        this.smequoteService.getIIRISProductcodes(this.partnerID, this.productCode).subscribe(res => {

            this.IIRISCodes = res.Quotations;
            console.log("IIRIS Codes", this.IIRISCodes)

        })
    }

    getLegalStatus() {
        this.smequoteService.getLegalStatus(this.partnerID).subscribe(res => {

            this.legalStatus = res.Quotations;

        })
    }
    setupYears() {
        const currentYear = new Date().getFullYear();
        const startYear = 1951;
        const endYear = currentYear;
        // const endYear = currentYear + 50; 
        for (let year = startYear; year <= endYear; year++) {
            this.years.push(year);
        }
    }

    onYearSelected(year: number) {
        this.selectedYear = year;
        console.log('Selected Year:', this.selectedYear);
    }
    OnAssigntoUW(name: string) {
        console.log(name);
        this.RefAssignedTo = name['email'];
        console.log(this.RefAssignedTo);
    }

    getannualover() {
        this.smequoteService.getannualturnover(this.partnerID).subscribe(res => {

            this.turnOver = res.Quotations;

        })
    }
    getNatureOfWork() {
        this.smequoteService.getNatureofWork(this.partnerID,this.productCode).subscribe(res => {

            this.natureofwork = res.Quotations;

        })
    }

    
    getEquipmentType() {
        this.smequoteService.getEquipmentType(this.partnerID).subscribe(res => {

            this.equipmentTypeList = res.Quotations;

        })
    }
    getcliamhistory() {
        this.smequoteService.getClaimHistory(this.partnerID).subscribe(res => {

            this.claimHistory = res.Quotations;

        })
    }
    getemirates() {
        this.smequoteService.getEmirates(this.partnerID).subscribe(res => {

            this.emirates = res.Quotations;

        })
    }
    getConstClass() {
        this.smequoteService.getConstructionClass(this.partnerID,1).subscribe(res => {

            this.conclass = res.Quotations;

        })
    }
    getIndSegment() {
        this.smequoteService.getIndustrySegment(this.partnerID, this.productCode).subscribe(res => {

            this.indSegment = res.Quotations;

        })
    }
    getBusinessPremise() {
        this.smequoteService.getbusinesspremise(this.partnerID).subscribe(res => {

            this.bussPremise = res.Quotations;

        })
    }
    getBusinessSegment(data, i) {
        console.log(data)
        this.businessSegmentLoader = this.globalService.spinnerShow();



        this.smequoteService.getBusinesSegment(this.partnerID, this.locations.at(i).get('industryType').value.IndustryId, this.productCode).subscribe(res => {
            console.log("Business Segmetn Response", res);
            if (res.res_code == 1) {
                this.busseg[i] = res.Quotations;
                this.businessSegmentLoader = this.globalService.spinnerHide();
                if (data != '') {
                    var businesssegIndex = this.busseg[i].findIndex((obj, key) => {
                        return obj.BusinessName == data
                    })
                    console.log("Index", this.busseg)
                    console.log("Index", businesssegIndex)
                    this.locations.at(i).get('businessSegment').setValue(this.busseg[i][businesssegIndex])
                }
            }

            console.log(this.busseg)
        })


    }
    getTypeofWork(data, i) {
        console.log(data)
        this.businessSegmentLoader = this.globalService.spinnerShow();



        this.smequoteService.getTypeofWork(this.partnerID, this.locations.at(i).get('natureofwork').value.Id).subscribe(res => {
            console.log("Business Segmetn Response", res);
            if (res.res_code == 1) {
                this.typeofwork[i] = res.Quotations;
                this.businessSegmentLoader = this.globalService.spinnerHide();
                if (data != '') {
                    var typeofworkIndex = this.typeofwork[i].findIndex((obj, key) => {
                        return obj.TypeofWorkName == data
                    })
                    console.log("Index", this.typeofwork)
                    console.log("Index", typeofworkIndex)
                    this.locations.at(i).get('typeofwork').setValue(this.typeofwork[i][typeofworkIndex])
                }
            }
            if(this.locations.at(i).get('natureofwork').value.Id == 1)
            {
              this.locations.at(i).get('typeofwork').setValidators(Validators.required)
            }
            else
            {
              this.locations.at(i).get('typeofwork').clearValidators();
            }
            this.locations.at(i).get('typeofwork').updateValueAndValidity()
            console.log(this.busseg)
        })


    }
    getemiratesmall(data, i) {
        // console.log(this.smeQuoteDetails.value.emirates.Id);
        // console.log(data);
        if (data == '0') {
            this.emiId = null;
        } else {
            this.emiId = this.locations.at(i).value.emirates.Id;
        }
        this.emiratesmallLoader = this.globalService.spinnerShow();
        this.smequoteService.getemiratemall(this.partnerID, this.emiId).subscribe(res => {
            console.log(res);
            if (res.res_code == 1) {
                this.emrmall[i] = res.Quotations;
                this.emiratesmallLoader = this.globalService.spinnerHide();
                if (data != '') {
                    var emiratesmallIndex = this.emrmall[i].findIndex((obj, key) => {
                        return obj.Id == data
                    })
                    console.log(emiratesmallIndex)
                    this.locations.at(i).get('emirateMall').setValue(this.emrmall[i][emiratesmallIndex])
                }
            }

            console.log(this.emrmall)
        })

    }

    getQuotation(stepper) {
        if (this.smeQuoteDetails.invalid || this.locationForm.invalid) {
            this.validtnMsg = true;
            this.smeQuoteDetails.markAllAsTouched();
            return false;
        }
        if (this.quoteStatus != 'REFERRED' && this.quoteStatus != 'REFAPPROVED' && this.quoteStatus != 'ADDITIONALINFO') {
            this.quoteProceed = true;

        }
        if (this.quoteProceed == false) {
            Swal.fire("Check the coverage, This policy will not cover you if you are looking for a cover for the entire building which is having more than 10 floors with aluminium cladding/ any other combustible cladding.", "However if you are looking for covering only a few units within such building, then you can change no.of floors and proceed issuing policy from this portal", "error");
            return false;
        }
        this.quoteLoader = this.globalService.spinnerShow();

        console.log(this.quoteNumber)
        let processtype = (this.quoteNumber == '') ? 'Insert' : 'Update';
        let QuoteParamArray = []
        this.locationForm.value.locations.map((x, i) => {

            QuoteParamArray.push({
                EntityName: this.smeQuoteDetails.value.businessName.replace(this.characterToReplace, this.replacementCharacter),
                industry: {
                    IndustryId: 2
                },
                business: {
                    BusniessId: 13
                },
                natureofwork: x.natureofwork,
                typeofwork: x.typeofwork,
                projectPeriod: x.projectPeriod,
                maintenancePeriod: x.maintenancePeriod,
                projectTitle: x.projectTitle,
                scopeWork: x.scopeWork,
                emiratesid: x.emirates,
                emiratemall: x.emirateMall,
                ConstructionClass: x.construction,
                Premises: this.locations.length > 1 ? 2 : 1,
                Turnover: x.AnnualBusiness,
                OffShoreRequired: x.offshoreRequired,
                estYear: x.businessYear,
                claimHistory: this.smeQuoteDetails.value.claimHistory,
                cladding: x.buildingCladding,
                businessArea: x.businessArea,
                floors: x.NoOfFloors,
                riskLocation: x.projectLocation,
                partnerId: this.smeQuoteDetails.value.partner,
                userId: this.userId,
                quotationNumber: this.quoteNumber,
                quoteId: this.quoteId,
                brokerId: this.smeQuoteDetails.value.partner,
                branchId: this.smeQuoteDetails.value.branch.Id,
                productCode: this.productCode,
                lob_code: 'SM',
                processType: processtype,
                policyType: this.policyType,
                source: 'B2B',
                isRiskInMall: x.riskSelect,
                coverageRequired: x.coverageRequired,
                offshorerequired: x.offshorerequired,
                annualWages: x.annuallWages,
                equipmentType: x.equipmentType,
                equipmentQuantity: x.equipmentQuantity,
                equipmentYear: x.equipmentYear,
                equipmentValue: x.equipmentValue,
                equipmentMake: x.equipmentMake,
                equipmentModel: x.equipmentModel,
                equipmentNo: x.equipmentNo


            })
        });
        this.additionalDetailForm.get('BusinessEntityName').setValue(this.smeQuoteDetails.value.businessName)
        this.additionalDetailForm.get('BusinessEntityName').updateValueAndValidity();

        console.log(QuoteParamArray)
        this.smequoteService.getQuote(QuoteParamArray).subscribe(res => {
            this.ButtonName = 'Update Quote';
            this.isReferral = res.response_code;
            this.referalRes = res.referralReason;
            if(res.response_message == 'Rejected')
            {
                this.quoteLoader = this.globalService.spinnerHide(); 
                this.quoteNumber = res.quotation_number;
                //this.rejectionReason = res.rejectionReason;
                Swal.fire("Thank you for you request. However Please note the Quotation has been Rejected in our system.", res.rejectionReason, "error");
                return;
            }
            else if (res.response_code == 3 || res.response_code == 1 || this.quoteStatus == 'REFERRED' || this.quoteStatus == 'ADDITIONALINFO') {
                this.quoteLoader = this.globalService.spinnerHide();
                this.quoteNumber = res.quotation_number;
                this.benefitData = res.benefitData;
                this.IsRenewal = res.quotedetails[0].IsRenewal
                console.log(this.benefitData);
                this.planId = res.quotedetails[0].PlanId;
                this.serviceTax = res.quotedetails[0].ServiceTax;

                if (stepper != '') {
                    stepper.next();
                }

                if (this.uploadAddinfoDocumentinScreen && (this.quoteNumber != null && this.quoteNumber != undefined)) //prod issue fix- check quotenumber generated and then call the API
                {
                    this.uploadAddinfoDocument2(this.event, 'additionalDocument')
                }

              
                this.recalculatePremiums();
                this.saveChanges()
                this.getWordDoc();
                console.log("After Update Benefit data", this.benefitData)

            } else {
                this.quoteLoader = this.globalService.spinnerHide();
                this.quoteNumber = res.quotation_number;
                this.refferalButton = true;
                Swal.fire("Thank you for you request, based on your application details, the case needs to be referred to UW team for further review.Please click 'Refer A Quote' Button down", "If you need further assistance call us at 800-842", "error");
            }

        })

    }

    refQuotation() {
        if (this.smeQuoteDetails.invalid) {
            this.validtnMsg = true;
            this.smeQuoteDetails.markAllAsTouched();
            return false;
        }
        let QuoteParamArray = [{
            EntityName: this.smeQuoteDetails.value.businessName.replace(this.characterToReplace, this.replacementCharacter),
            industry: this.smeQuoteDetails.value.industryType,
            business: this.smeQuoteDetails.value.businessSegment,
            emiratesid: this.smeQuoteDetails.value.emirates,
            emiratemall: this.smeQuoteDetails.value.emirateMall,
            ConstructionClass: this.smeQuoteDetails.value.construction,
            Premises: this.locations.length > 1 ? 2 : 1,
            Turnover: this.smeQuoteDetails.value.AnnualBusiness,
            estYear: this.smeQuoteDetails.value.businessYear,
            claimHistory: this.smeQuoteDetails.value.claimHistory,
            cladding: this.smeQuoteDetails.value.buildingCladding,
            businessArea: this.smeQuoteDetails.value.businessArea,
            floors: this.smeQuoteDetails.value.NoOfFloors,
            riskLocation: this.smeQuoteDetails.value.Address,
            partnerId: this.smeQuoteDetails.value.partner,
            userId: this.userId,
            quotationNumber: this.quoteNumber,
            quoteId: this.quoteId,
            brokerId: this.smeQuoteDetails.value.partner,
            branchId: this.smeQuoteDetails.value.branch.Id,
            productCode: this.productCode,
            lob_code: 'SM',
            processType: 'Insert',
            policyType: this.policyType,
            source: 'B2B'
        }]
        this.smequoteService.getQuote(QuoteParamArray).subscribe(res => {
            // this.ButtonName ='Update Quote';
            // this.quoteLoader=this.globalService.spinnerHide();
            this.quoteNumber = res.quotation_number;
        })

    }

    //---------VALIDATION FOR NUMBERS & DECIMAL NUM------------//
    // checkValidInputData(event: any,type)
    // {
    //     this.globalService.checkValidInputData(event,type);
    // }
    back(stepper) {
        if (stepper != '') {
            stepper.previous();
        }

    }
    checkValidation(i) {
        // debugger;
        // alert(1)
   
    
        if (this.productCode == 'SMECPM' || this.productCode == 'SMEEAR') {
             if (this.additionalDetails.at(i).value.mortgageecheck.label == 'No') {
                this.madFileds = "";


                this.additionalDetails.at(i).get('mortgagee1').setValidators(null);
                this.additionalDetails.at(i).get('mortgagee2').setValidators(null);
                this.additionalDetails.at(i).get('assignmentValue').setValidators(null);
                this.additionalDetails.at(i).get('mortgagee1').setValue('');
                this.additionalDetails.at(i).get('mortgagee2').setValue('');
                this.additionalDetails.at(i).get('mortgagee1').updateValueAndValidity();
                this.additionalDetails.at(i).get('mortgagee2').updateValueAndValidity();
                this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity();
                if (!this.InitiatedQuote) {
                    this.additionalDetails.at(i).get('assignmentValue').setValue(0);
                    this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity()
                }
            } else {
                this.madFileds = "*";
                this.additionalDetails.at(i).get('mortgagee1').setValidators([Validators.required]);
                this.additionalDetails.at(i).get('mortgagee2').setValidators([Validators.required]);
                this.additionalDetails.at(i).get('assignmentValue').setValidators([Validators.required]);
                this.additionalDetails.at(i).get('mortgagee1').updateValueAndValidity();
                this.additionalDetails.at(i).get('mortgagee2').updateValueAndValidity();
                this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity()
            }
        } else {
            this.madFileds = "";
            this.additionalDetails.at(i).get('mortgageecheck').setValue('No');
            this.additionalDetails.at(i).get('mortgageecheck').setValidators(null);
            this.additionalDetails.at(i).get('mortgagee1').setValidators(null);
            this.additionalDetails.at(i).get('mortgagee2').setValidators(null);
            this.additionalDetails.at(i).get('assignmentValue').setValidators(null);
            this.additionalDetails.at(i).get('mortgagee1').setValue('');
            this.additionalDetails.at(i).get('mortgagee2').setValue('');
            this.additionalDetails.at(i).get('mortgagee1').updateValueAndValidity();
            this.additionalDetails.at(i).get('mortgagee2').updateValueAndValidity();
            this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity();
            this.additionalDetails.at(i).get('mortgageecheck').updateValueAndValidity();
        }

    }

    GeoCheckValidation() {
        console.log(this.totalcar);
        this.additionalDetails.controls.forEach((locationEl, locationindex) => {
            if (config.enableGeoLocValid == 'Y') {
                this.additionalDetails.at(locationindex).get('companyAddressGeoLocation').setValidators([Validators.required]);
                this.additionalDetails.at(locationindex).get('companyAddressGeoLocation').updateValueAndValidity()
            } else {
                this.additionalDetails.at(locationindex).get('companyAddressGeoLocation').setValidators(null);
                this.additionalDetails.at(locationindex).get('companyAddressGeoLocation').updateValueAndValidity()
            }
        });


        if (this.totalcar[0] > 0) {
            this.showIcon = true;
        } else {
            this.showIcon = false;
        }
    }

    vatCheckValidation(i) {
        // this.docUploadFlag = true;
        if (this.additionalDetailForm.value.vatRegcheck.label == 'No') {
            this.additionalDetails.controls.map((x, i) => {
                this.additionalDetails.at(i).get('trnNo').setValidators(null); // Not Mandatory
                this.additionalDetails.at(i).get('trnNo').updateValueAndValidity();
            })

            //console.log(this.additionalDetails[i].get('trnNo').validator)

            this.docListpol.forEach((element, index) => {
                // if(this.docUploadFlag == true){
                if (element.DocumentName == 'VAT Certificate') {
                    element.MandatorySymbol = '';
                }
                if (element.DocumentName == 'No VAT Declaration Letter') {
                    element.MandatorySymbol = '*';
                }
                // }
            });
        } else {
            this.additionalDetails.controls.map((x, i) => {
                this.additionalDetails.at(i).get('trnNo').setValidators(Validators.required); // Required Field validator 
                this.additionalDetails.at(i).get('trnNo').updateValueAndValidity();
            })

            // console.log(this.additionalDetailForm.get('trnNo'))

            this.docListpol.forEach((element, index) => {
                // if(this.docUploadFlag == true){
                if (element.DocumentName == 'VAT Certificate') {
                    element.MandatorySymbol = '*';
                }
                if (element.DocumentName == 'No VAT Declaration Letter') {
                    element.MandatorySymbol = '';
                }
                // }
            });

            console.log("Document List", this.docList)
        }
    }
    // ---------------------------------------dropdown For Partner And Branch-------------------------------------------------
    getQuotationFormData() {
        // this.quoteRes=this.globalService.spinnerShow();
        console.log("PartnerId inside Quotation Form", this.partnerID);
        this.issuepolicyService.getQuotationFormData().subscribe(response => {
            this.formDataRes = response;
            console.log("FormData", this.formDataRes)
            console.log("Partner Id form", this.partnerID)
            // this.quoteRes = this.globalService.spinnerHide();
            this.partnersArr = this.formDataRes.Partners;

            // if(this.quatationNo =='' ){
            //  console.log(this.partnerId)
            this.partnersArr.forEach((item, index) => {

                if (item.PartnerId == this.partnerID) {
                    console.log(item.PartnerId)
                    this.partnerVal = item.PartnerId;

                }

            });
            console.log("Partner Id form", this.partnerVal)
            //  console.log(this.partnerVal);

            //  if(this.partnerID == 1){
            //   this.getPartnerBranchList();
            // }
            //   else{
            //     this.getUserBranchList();
            //   }
            //  }
            if (!this.InitiatedQuote) {
                this.smeQuoteDetails.get('partner').setValue(this.partnerVal);
                this.getPartnerBranchList();
            }



        });

    }

    getPartnerBranchList() {
        this.partnerBranchArr = [];
        // this.loader=this.globalService.spinnerShow();
        this.issuepolicyService.getpartnerBranch(this.smeQuoteDetails.value.partner).subscribe(res => {
            let updateRes: any = res;
            // this.loader=this.globalService.spinnerHide();
            updateRes.branchList = updateRes.branchList.filter(a => a.BranchCode != 'ONL')
            this.partnerBranchArr = updateRes.branchList;
            if (this.disabledbr || this.quoteStatus == 'REFERRED') {
                this.userBranchArr = updateRes.branchList;
            }
            //UW changes -shuhaib
            if ((this.userRole == "TELEMARKETING" || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.businessSource == "DIRECT") {
                const routeParams = this._activatedroute.snapshot.params;
                if (routeParams.quoteNumber) {
                    this.branchId = updateRes.branchList.filter(b => b.Id == this.quotation_branchId)[0];
                } else {
                    this.branchId = updateRes.branchList[0];
                }

                console.log('branches list', JSON.stringify(this.branchId));
                this.smeQuoteDetails.get('branch').setValue(this.branchId);
            } else {
                this.branchId = updateRes.branchList[0];
                this.partnerBranchArr.forEach((item, index) => {
                    if (item.Id == this.branchId.Id) {
                        this.branchVal = item;
                    }
                });
                this.smeQuoteDetails.get('branch').setValue(this.branchVal);
            }


            //  branch
            // if(this.quatationNo == ''){




            // }



        });
        this.showLoader.load_data = false;
    }

    getUserBranchList() {
        this.userBranchArr = [];
        // this.loader=this.globalService.spinnerShow();
        this.issuepolicyService.getuserBranch(this.userID).subscribe(res => {
            let updateRes: any = res;
            // this.loader=this.globalService.spinnerHide();
            this.userBranchArr = updateRes.branchList;
            this.branchId = updateRes.branchList[0];

            this.userBranchArr.forEach((item, index) => {
                if (item.Id == this.branchId.Id) {
                    this.branchVal = item;

                }
            });
            this.smeQuoteDetails.get('branch').setValue(this.branchVal);
        });
        this.showLoader.load_data = false;
    }
    preventAllEvents(event: any) {
        this.globalService.preventAllEvents(event);
    }
    getZone() {
        this.smequoteService.getfreezone(this.smeQuoteDetails.value.partner).subscribe(res => {
            this.freezzone = res.freezones;
            // this.benefitData.map((x,i)=>{
            //   this.additionalDetails.at(i).get('freezzone').setValue( this.freezzone[0])
            // })


        })
    }
    checksumCal(data, val, index, locindex) {

        console.log(val)
        console.log(data.BenefitSI)
        data.checked = true;
        val = val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.DefaultSumCovered = val;
        data.defaultCover = val.replace(/,/gi, "");

        data.sectionsBenefitSI = data.BenefitSI.replace(/,/gi, "");
        val = val.replace(/,/gi, "");
        console.log(data.DefaultSumCovered.replace(/,/gi, ""))
        if (parseInt(data.BenefitSI) < parseInt(val) && !this.enableCoverStartDateModify) {

            data.DefaultSumCovered = data.SumCover.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // if(this.benefitData[index].BenefitName == "As per UAE Labour Law with estimated annual wages not exceeding")
            // {
            //   this.adminCount = 1;
            //   this.nonAdminCount = 0;
            //   this.adminSumInsured = data.SumCover.replace(/\D/g, "") .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            //   this.nonAdminSumInsured = 0;
            // }
            Swal.fire('Invalid Sum Insured', data.BenefitName + ',' + 'cannot be more than' + ' ' + (data.BenefitSI).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","), 'error');

        }


        // if(this.policyType == "RENEWAL" || this.quoteStatus == "RENQUOTE"){
        //   if(this.partnerID == 1){
        //     this.valueRatio = parseInt(this.benefitData[index].SumCover) + (parseInt(this.benefitData[index].SumCover) * 0.25);
        //     // console.log(this.valueRatio)
        //     // console.log(this.benefitData[index].SumCover)
        //     if(this.valueRatio < parseInt(val)){
        //       this.benefitData[index].DefaultSumCovered=data.SumCover.replace(/\D/g, "") .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //       Swal.fire('Invalid Sum Insured',data.BenefitName+ ',' +'cannot be increased more than 25% of already Sum Insured','error');
        //     }
        //   }else{
        //     this.valueRatio = parseInt(this.benefitData[index].SumCover) + (parseInt(this.benefitData[index].SumCover) * 0.15);
        //     if(this.valueRatio < parseInt(val)){
        //       this.benefitData[index].DefaultSumCovered=data.SumCover.replace(/\D/g, "") .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //       Swal.fire('Invalid Sum Insured',data.BenefitName+ ',' +'cannot be increased more than 15% of already Sum Insured','error');
        //     } 
        //   }
        // }

        this.premiumCalucation();
    }
   checkCheckboxSelection(value, index, item) {

        if (!value.checked) {
            // alert(1)
            item.checked = false;
            item.DefaultSumCovered = 0;

            // this.currentSubArray[index].checked=false;
            // this.currentSubArray[index].DefaultSumCovered=0;
            this.premiumCalucation();

        } else {
            //this.currentSubArray[index].DefaultSumCovered=item.SumCover.replace(/\D/g, "") .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            item.DefaultSumCovered = item.SumCover.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.premiumCalucation();
        }
    }

    premiumCalucation() {
       
        // this.eLAddedTax= [];
        this.insuredAmount = [];

        this.recalculatePremiums();

    }


    totalPremiumCalculation() {
        this.Vat_Amount = 0;
        this.totalPremium = 0;
        this.totalbasepremium = 0;
        this.totalsumCoveredAll = 0;
        this.basePremium.forEach((x, i) => {
            this.totalbasepremium += Number(x);
        })

        this.totalsumCovered.forEach((x, i) => {
            this.totalsumCoveredAll += Number(x);
        })
        this.Vat_Amount += (this.totalbasepremium + this.loadingAmount + this.policyFee - this.discountAmount) * 0.05;

        this.totalPremium += this.totalbasepremium + this.Vat_Amount + this.policyFee + this.loadingAmount - this.discountAmount;

    }

    getLoadingBy() {
        this.loadingAmount = 0;
        console.log(this.loadingby)


        this.loadingAmount = this.totalbasepremium * (this.loadingby / 100);
        this.totalPremiumCalculation();
    }

    getDiscountBy() {
        this.discountAmount = 0;
        console.log(this.loadingby)


        this.discountAmount = this.totalbasepremium * (this.discountby / 100);
        this.totalPremiumCalculation();
    }

    getLoadingByEdit() {
        this.loadingAmount = 0;
        this.loadingby = this.LoadingRate;
        this.loadingAmount = this.totalbasepremium * (this.loadingby / 100);
        this.totalPremiumCalculation();
    }

    getDiscountByEdit() {
        this.discountAmount = 0;
        this.discountby = this.DiscountRate;
        this.discountAmount = this.totalbasepremium * (this.discountby / 100);
        this.totalPremiumCalculation();
    }

    getWordDoc() {
        this.smequoteService.getWordingDocuments('SM', 'B2B', this.productCode).subscribe(res => {
            this.worDoc = res.wordingdocs;

        })
    }
    printDoc(value) {
        window.open(value, "_blank");
    }
    getEditData() {
        // this.smequoteService.getProcessSMERenewal('B2B', this.productCode,'eng',this.policyNumber,'RENQUOTE','RENEWAL',this.claimCount,this.claimAmount,this.expiringPremium).subscribe(res=>{
        this.smequoteService.getProcessSMERenewal('B2B', this.productCode, 'eng', this.policyNumber, 'RENQUOTE', 'RENEWAL', 0, 0, 0).subscribe(res => {
            let quotedetail = res.quotedetails;
            console.log("Quotation Details", quotedetail)
            this.quoteId = quotedetail.QuotationId;
            this.quoteNumber = res.quotation_number;
            this.expiryDate = res.quotedetails[0].ExpiryDate;
            this.dtminDate = new Date(this.expiryDate);
            if (this.dtminDate > this.minDate) {
                this.disableDate = true;
                this.dtminDate.setDate(this.dtminDate.getDate() + 1);
                this.dtmaxDate = new Date(this.dtminDate);
                this.dtmaxDate.setDate(this.dtmaxDate.getDate() + 45);
            } else {
                this.disableDate = false;
                this.dtminDate = new Date(this.minDate);
                this.dtmaxDate = new Date(this.dtminDate);
                this.dtmaxDate.setDate(this.dtmaxDate.getDate() + 45);
            }
            quotedetail.map((x, i) => {
                this.smeQuoteDetails.get('startDate').setValue(this.dtminDate);
            })
            // Partner Name

            //this.smeQuoteDetails.get('businessArea').setValue(quotedetail.PartnerId); -- commented now
            //underWriter changes for broker and branch- shuhaib
            console.log('partnerID', this.partnerID);
            console.log('BranchId', quotedetail.BranchId);

            if ((this.userRole == "TELEMARKETING" || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.businessSource == "DIRECT") {
                this.smeQuoteDetails.get("partner").setValue(quotedetail[0].CedantBrokerId);
                this.quotation_branchId = quotedetail.BranchId;
            }

            // Branch 
            // if(this.partnerID == 1){
            //   this.getPartnerBranchList();
            // }
            //   else{
            //     this.getUserBranchList();
            //   }
            this.getPartnerBranchList();
            this.smeQuoteDetails.get('businessName').setValue(quotedetail[0].BusinessEntityName);
            this.additionalDetailForm.get('BusinessEntityName').setValue(quotedetail[0].BusinessEntityName)
            this.additionalDetailForm.get('BusinessEntityName').updateValueAndValidity();
            // Business Area Name
            quotedetail.map((quoteData, index) => {
                if (index > 0) {
                    this.addLocation();
                }
                this.locations.at(index).get('riskSelect').setValue(quoteData.IsRiskInMall.trim());
                console.log("quotedetails", index)
                // if(!this.InitiatedQuote){
                //   let businessArea =quoteData.BusinessArea
                //   var businessIndex = this.bArea.findIndex((obj, k) =>{

                //     return obj.BusinessAreaName == businessArea;
                //   });
                //  this.locations.at(index).get('businessArea').setValue(this.bArea[businessIndex]); 
                // }
                // Industry Name
                if (!this.InitiatedQuote) {
                    let industryName = quoteData.IndustryName
                    var industryIndex = this.indSegment.findIndex((obj, k) => {

                        return obj.IndustryName == industryName;
                    });
                    this.locations.at(index).get('industryType').setValue(this.indSegment[industryIndex]);
                }
                this.getBusinessSegment(quoteData.BusinessName, index);
                // emirate Name
                if (!this.InitiatedQuote) {
                    let regionName = quoteData.EmiratesName
                    var emirateIndex = this.emirates.findIndex((obj, k) => {

                        return obj.RegionName == regionName;
                    });
                    this.locations.at(index).get('emirates').setValue(this.emirates[emirateIndex]);
                    // this.getemiratesmall(quotedetail.MallId);
                    if (regionName == null) {
                        this.getemiratesmall('0', index);
                    } else {
                        this.getemiratesmall(quoteData.MallId, index);
                    }
                }
                this.locations.at(index).get('Address').setValue(quoteData.RiskLocationAddress);

                if (this.productCode == 'SMEPAR' || this.productCode == 'SMEB1') {
                    // Insuring Property
                    if (quoteData.FloorsCount == '0') {
                        // alert(1)
                        this.locations.at(index).get('insuringProperty').setValue(this.optionyesNo[1]);
                        this.checkValidation(index);
                    } else {
                        this.locations.at(index).get('insuringProperty').setValue(this.optionyesNo[0]);
                        this.checkValidation(index);

                        this.locations.at(index).get('businessYear').setValue(quoteData.BusinessEstYear);

                        let classconstruction = quoteData.ConstructionClassName
                        var constIndex = this.conclass.findIndex((obj, k) => {

                            return obj.ConstructionClassName == classconstruction;
                        });
                        this.locations.at(index).get('construction').setValue(this.conclass[constIndex]);



                        // let bussinessPrem =quoteData.BusinessPremise
                        // var premIndex = this.bussPremise.findIndex((obj, k) =>{

                        //   return obj.BusinessPremise == bussinessPrem;
                        // });
                        // this.locations.at(index).get('businessPremises').setValue(this.bussPremise[premIndex]); 




                        let annual = quoteData.AnnualTurnover
                        var annualIndex = this.turnOver.findIndex((obj, k) => {

                            return obj.AnnualTurnover == annual;
                        });
                        console.log(annualIndex)
                        this.locations.at(index).get('AnnualBusiness').setValue(this.turnOver[annualIndex]);


                        if (quoteData.PremisesWithCladding == 'N') {
                            // alert(1)
                            this.locations.at(index).get('buildingCladding').setValue(this.optionyesNo[1]);

                        } else {
                            this.locations.at(index).get('buildingCladding').setValue(this.optionyesNo[0]);
                        }

                        let nooffloor = quoteData.FloorsCount
                        // var floorindex = this.noofFloor.findIndex((obj, k) =>{

                        //   return obj.AnnualTurnover == annual;
                        // });
                        // console.log(annualIndex)
                        // this.smeQuoteDetails.get('NoOfFloors').setValue(this.noofFloor[1]);
                        if (quoteData.FloorsCount == '1') {
                            // alert(1)
                            this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[0]);
                            // this.checkValidation();
                        }
                        if (quoteData.FloorsCount == '2') {
                            // alert(1)
                            this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[1]);
                            // this.checkValidation();
                        }
                        if (quoteData.FloorsCount == '3') {
                            // alert(1)
                            this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[2]);
                            // this.checkValidation();
                        }


                    }
                } else {
                    this.locations.at(index).get('insuringProperty').setValue(this.optionyesNo[0]);


                    this.locations.at(index).get('businessYear').setValue(quoteData.BusinessEstYear);

                    let classconstruction = quoteData.ConstructionClassName
                    var constIndex = this.conclass.findIndex((obj, k) => {

                        return obj.ConstructionClassName == classconstruction;
                    });
                    this.locations.at(index).get('construction').setValue(this.conclass[constIndex]);



                    // let bussinessPrem =quoteData.BusinessPremise
                    // var premIndex = this.bussPremise.findIndex((obj, k) =>{

                    //   return obj.BusinessPremise == bussinessPrem;
                    // });
                    // this.locations.at(index).get('businessPremises').setValue(this.bussPremise[premIndex]); 




                    let annual = quoteData.AnnualTurnover
                    var annualIndex = this.turnOver.findIndex((obj, k) => {

                        return obj.AnnualTurnover == annual;
                    });
                    console.log(annualIndex)
                    this.locations.at(index).get('AnnualBusiness').setValue(this.turnOver[annualIndex]);


                    if (quoteData.PremisesWithCladding == 'N') {
                        // alert(1)
                        this.locations.at(index).get('buildingCladding').setValue(this.optionyesNo[1]);

                    } else {
                        this.locations.at(index).get('buildingCladding').setValue(this.optionyesNo[0]);
                    }

                    let nooffloor = quoteData.FloorsCount
                    // var floorindex = this.noofFloor.findIndex((obj, k) =>{

                    //   return obj.AnnualTurnover == annual;
                    // });
                    // console.log(annualIndex)
                    // this.smeQuoteDetails.get('NoOfFloors').setValue(this.noofFloor[1]);
                    if (quoteData.FloorsCount == '1') {
                        // alert(1)
                        this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[0]);
                        // this.checkValidation();
                    }
                    if (quoteData.FloorsCount == '2') {
                        // alert(1)
                        this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[1]);
                        // this.checkValidation();
                    }
                    if (quoteData.FloorsCount == '3') {
                        // alert(1)
                        this.locations.at(index).get('NoOfFloors').setValue(this.noofFloor[2]);
                        // this.checkValidation();
                    }


                }

                // Claiming History
                if (!this.InitiatedQuote) {
                    let claimName = quoteData.ClaimHistory
                    var claimIndex = this.claimHistory.findIndex((obj, k) => {

                        return obj.ClaimHistory == claimName;
                    });
                    this.smeQuoteDetails.get('claimHistory').setValue(this.claimHistory[claimIndex]);
                    this.getQuotationHistory(this.quoteNumber);
                    this.pageLoader = this.globalService.spinnerHide();
                } else {
                    this.pageLoader = this.globalService.spinnerHide();
                }
            })
        })

    }

    getQuoteDetails() {
        this.smequoteService.getQuotationDetails('SMEBI', this.quoteNumber, this.smeQuoteDetails.value.partner, this.source).subscribe(result => {
            let quotedetail = result.quotedetails;
            console.log("Get Quote Details", quotedetail)
            this.quoteDocumentsList = result.quoteDocuments[0];
            console.log(this.quoteDocumentsList)
            this.EmployeeHeaderData = result.EmployeeHeaderData
            this.quoteConditions = result.quoteConditions
            this.benefitData = result.benefitData


            if (this.quoteConditions.length > 0) {

                this.conditions = this.quoteConditions.map(x => {
                    let conditionTypeName = x.conditionType;
                    let product_code = x.productCode;
                    let productCodeObj = this.IIRISCodes.find(code => code.value === product_code);
                    let conditionTypeObj = this.conditionType.find(type => type.value === conditionTypeName);

                    // Return a new object with the mapped values
                    return {
                        productCode: productCodeObj ? productCodeObj : '',
                        conditionType: conditionTypeObj ? conditionTypeObj : '',
                        description: x.description || '' // Default to empty if no description
                    };
                });
                console.log(this.conditions)
            }

           
            if (quotedetail[0].StatusDesc == 'REFAPPROVED') {
                this.reapprove = true;
            } else {
                this.reapprove = false;
            }

            if (quotedetail[0].StatusDesc == 'QUOTED' || quotedetail[0].StatusDesc == 'REFAPPROVED' || quotedetail[0].StatusDesc == 'RENQUOTE') {
                this.buttonds = false;
            } else if (this.partnerID == 1) {
                this.buttonds = false;
            } else {
                this.buttonds = true;
            }
            if (quotedetail[0].StatusDesc == 'INITIATED') {
                this.InitiatedQuote = true;
            } else {
                this.InitiatedQuote = false;
            }


            this.claimCount = quotedetail[0].ClaimCount;
            this.claimAmount = quotedetail[0].ClaimAmount;
            this.expiringPremium = quotedetail[0].ExpiringPremium;
            this.quoteId = quotedetail[0].QuotationId;
            this.quoteNumber = result.quotation_number;
            if (this.InitiatedQuote) {
                this.GetInitiatedPolicyDetails(this.quoteNumber);
            }
            this.quoteStatus = result.quotedetails[0].StatusDesc;
            this.TotalCont = quotedetail[0].TotalContribution;
            this.ValueAddedT = quotedetail[0].ValueAddedTax;
            this.PremiumLoad = quotedetail[0].PremiumLoading;
            this.LoadingRate = quotedetail[0].LoadingRate;
            this.PremiumDisc = quotedetail[0].PremiumDiscount;
            this.DiscountRate = quotedetail[0].DiscountRate;
            //this.IsRenewal = quotedetail[0].IsRenewal

            this.additionalDetailForm.get('BusinessEntityName').setValue(result.quotedetails[0].BusinessEntityName)
            this.additionalDetailForm.get('BusinessEntityName').updateValueAndValidity();


            this.expiryDate = result.quotedetails[0].ExpiryDate;
            this.dtminDate = new Date(this.expiryDate);
            if (this.dtminDate > this.minDate) {
                this.disableDate = true;
                this.dtminDate.setDate(this.dtminDate.getDate() + 1);
                this.dtmaxDate = new Date(this.dtminDate);
                this.dtmaxDate.setDate(this.dtmaxDate.getDate() + 45);
            } else {
                this.disableDate = false;
                this.dtminDate = new Date(this.minDate);
                this.dtmaxDate = new Date(this.minDate);
                this.dtmaxDate.setDate(this.dtmaxDate.getDate() + 45);
            }
            this.benefitData.map((x, i) => {
                this.additionalDetailForm.get('CoverStartDate').setValue(this.dtminDate);

            })

            
            //underWriter changes for broker and branch- shuhaib
            console.log('partnerID', this.partnerID);
            console.log('BranchId', quotedetail[0].BranchId);
            if ((this.userRole == "TELEMARKETING" || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.businessSource == "DIRECT") {
                this.smeQuoteDetails.get("partner").setValue(quotedetail[0].CedantBrokerId);
                this.quotation_branchId = quotedetail[0].BranchId;
            } else {
                this.smeQuoteDetails.get('partner').setValue(quotedetail[0].PartnerId);
            }
            // Branch 
            // if(this.partnerID == 1){
            //   this.getPartnerBranchList();
            // }
            //   else{
            //     this.getUserBranchList();
            //   }
            this.getPartnerBranchList();
            this.smeQuoteDetails.get('businessName').setValue(quotedetail[0].BusinessEntityName);
            // Business Area Name
            quotedetail.map((quoteData, index) => {

                console.log("Location Update List", this.locations)
                if (index > 0) {
                    this.addLocation();
                }

         
                //this.locations.at(index).get('equipmentType').setValue(quotedetail[0].EquipmentType);
                this.locations.at(index).get('equipmentQuantity').setValue(quoteData.EquipmentQuantity);
                this.locations.at(index).get('equipmentYear').setValue(quoteData.EquipmentYear);
                this.locations.at(index).get('equipmentValue').setValue(quoteData.EquipmentValue);
                this.locations.at(index).get('equipmentMake').setValue(quoteData.EquipmentMake);
                this.locations.at(index).get('equipmentModel').setValue(quoteData.EquipmentModel);
                this.locations.at(index).get('equipmentNo').setValue(quoteData.EquipmentNo);
                let equipmentType = quoteData.EquipmentType
                var equipmentTypeindex  = this.equipmentTypeList.findIndex((obj, k) => {

                    return obj.Id == equipmentType
;
                });
                this.locations.at(index).get('equipmentType').setValue(this.equipmentTypeList[equipmentTypeindex]);

                
                

                //  let typeofwork = quoteData.TypeOfWork
                // var typeofworkindex = this.typeofwork.findIndex((obj, k) => {

                //     return obj.TypeofWorkName == typeofwork;
                // });
                // this.locations.at(index).get('typeofwork').setValue(this.typeofwork[typeofworkindex]);

                // this.getTypeofWork("Civil Work", index);

                //this.locations.at(index).get('Address').setValue(quoteData.RiskLocationAddress); 

                // Claiming History

                let claimName = quoteData.ClaimHistory
                var claimIndex = this.claimHistory.findIndex((obj, k) => {

                    return obj.ClaimHistory == claimName;
                });
                this.smeQuoteDetails.get('claimHistory').setValue(this.claimHistory[claimIndex]);
                this.getQuotationHistory(this.quoteNumber);
                this.pageLoader = this.globalService.spinnerHide();



            })

        })
        console.log("Location Form in update", this.locationForm)
        this.locationForm.updateValueAndValidity();
        console.log(this.locationForm.get('locations'));

        //console.log("Location Form in update",this.locations.controls[0].controls.AnnualBusiness.validator)
        //console.log(this.locationForm.get('locations').controls[0].get('AnnualBusiness').validator);


    }

    // ---------------------------------------Get Quotation History -----------------------------------------------
    getQuotationHistory(quoteNumber) {
        this.motorQuoteService.getQuotationHistory(quoteNumber, 'SM').subscribe(res => {
            if (res.response_code == 1) {
                this.quotationHistoryArr = res.quotationHistoryList;
                if ((this.userRole == "TELEMARKETING" || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.businessSource == "DIRECT") {
                    this.filteredquotationHistoryArr = this.quotationHistoryArr
                } else {
                    this.filteredquotationHistoryArr = this.quotationHistoryArr.filter(item =>
                        !item.StatusCode.includes('QUOTATION REASSIGNED')
                    );
                }


            }


        });
    }
    saveQuotePlanDetail(stepper, type) {

        console.log(this.benefitData)
        this.approveButton = true
        this.isToBeReferred = false;
        this.saveChanges();
        if (this.totalbasepremium == 0) {
            Swal.fire("", "Base Premium cannot be zero", 'error');
            return;
        } else {
            this.quotationloader = this.globalService.spinnerShow();
            let quotedetails = [];
            let EmployeeHeaderdetails = []

            this.benefitData.forEach((locationElement, locIndex) => {
                quotedetails.push({
                    QuotationNumber: this.quoteNumber,
                    partnerId: this.smeQuoteDetails.value.partner,
                    industry: {
                        "IndustryId": 2,
                        "IndustryName": "Shops/Trading"
                    },
                    business: {
                        "BusniessId": 13,
                        "BusinessName": "Bag and Luggage shop "
                    },
                    emiratesid: this.locations.at(locIndex).value.emirates,
                    emiratemall: this.locations.at(locIndex).value.emirateMall,
                    FireContribution: this.totalbasepremium,
                    AllRiskContribution: 0,
                    OptionalContribution: 0,
                    FixedPlanContribution: this.totalbasepremium, //this.basePremium.reduce((acc, curr) => acc + curr, 0),
                    FixedPlanId: this.planId,
                    ServiceTax: this.serviceTax,
                    ServiceTaxRate: 0,
                    policyFee: this.policyFee,
                    TotalContribution: this.totalPremium,
                    VATAmount: this.Vat_Amount,
                    VATTaxRate: 5,
                    PremLoading: this.loadingAmount,
                    PremLoadingRate: this.loadingby,
                    PremDiscount: this.discountAmount,
                    PremDiscountRate: this.discountby,
                    productCode: this.productCode,
                    brokerCommission: this.brokerCommissionPercentage,
                    lob_code: 'SM',
                    processType: 'INSERT',
                    policyType: 'NEW',
                    source: 'B2B'

                })
                EmployeeHeaderdetails.push({
                        EmployeeType: 'Admin',
                        EmployeeCount: this.adminCount[locIndex],
                        SumInsured: this.adminSumInsured[locIndex],
                        LocationId: Number(locIndex + 1),
                        policyType: 'WC'
                    }, {
                        EmployeeType: 'Non Admin',
                        EmployeeCount: this.nonAdminCount[locIndex],
                        SumInsured: this.nonAdminSumInsured[locIndex],
                        LocationId: Number(locIndex + 1),
                        policyType: 'WC'
                    },

                )


            })

            this.smequoteService.saveQuotationDetails(quotedetails, this.benefitData, EmployeeHeaderdetails).subscribe(res => {

                if (type == 1) {
                    this.quotationloader = this.globalService.spinnerHide();
                    Swal.fire('Quotation Saved Successfully', 'Your SME quotation has been saved successfully.', 'success');


                } else if (type == 2) {

                    this.isToBeReferred = this.CheckReferralConditions();
                    if (this.isToBeReferred) {
                        this.refferalButton = true;

                        Swal.fire("Thank you for you request, based on your application details, the case needs to be referred to UW team for further review.Please click 'Refer A Quote' Button down", "If you need further assistance call us at 800-842", "error");
                        return false;
                    }
                    this.smequoteService.getQuotationDetails(this.productCode, this.quoteNumber, this.smeQuoteDetails.value.partner, this.source).subscribe(result => {

                        let quotedetail = result.quotedetails[0];
                        this.quoteId = quotedetail.QuotationId;
                        this.quoteNumber = result.quotation_number;
                        this.quoteStatus = result.quotedetails[0].StatusDesc;
                        let noLoc = result.quotedetails
                        //this.IsRenewal = quotedetail[0].IsRenewal

                        //  this.additionalDetails.at(i).get('entityName').setValue(result.quotedetails[0].BusinessEntityName);
                        //this.additionalDetails.at(i).get('companyAddress').setValue(result.quotedetails[0].RiskLocationAddress);
                        this.smequoteService.getDocumentList('B2B', 'SM', 99999, this.quoteNumber).subscribe(result => {
                            this.docListpol = result.getDocumentsList.filter((x: any) => x.Type === 'POLICY');

                            console.log(this.docListpol)
                            // this.additionalDetails.at(i).get('documents').setValue
                            this.quotationloader = this.globalService.spinnerHide();
                            debugger;
                            console.log("WC Changes", this.WCMandatory.length)
                            noLoc.forEach((element, i) => {
                                this.docList[i] = result.getDocumentsList.filter((x: any) => x.Type === 'RISK');


                                console.log(this.docList[i])
                                // Employee list is made non mandatory
                                // if (this.WCMandatory.filter(d => d == i).length > 0) {
                                //   this.docList[i]= this.docList[i].map(document => {
                                //     if (document.DocumentId === 155 && document.Type == 'RISK') {
                                //       document.MandatorySymbol = '*';
                                //     }

                                //     return document;
                                //   });
                                // } 
                            });




                        })

                    })
                    console.log("Document List", this.docList)
                    if (this.globalService.flag) {
                        this.checkPartnerCreditLimit() //Remove on account option as per new regulation
                    }

                    if (stepper != '') {
                        stepper.next();
                    }
                } else if (type == 3) {
                    this.isToBeReferred = this.CheckReferralConditions();
                    if (this.isToBeReferred) {
                        this.refferalButton = true;

                        Swal.fire("Thank you for you request, based on your application details, the case needs to be referred to UW team for further review.Please click 'Refer A Quote' Button down", "If you need further assistance call us at 800-842", "error");
                        return false;
                    }
                    let QuoteArray = [{
                        productCode: this.productCode,
                        lob_code: 'SM',
                        processType: 'INSERT',
                        policyType: this.quoteStatus == 'RENQUOTE' ? 'RENEWAL' : 'NEW',
                        source: 'B2B'
                    }]
                    this.smequoteService.printsmepdf(QuoteArray, this.quoteNumber).subscribe(res => {

                        // res.pdfPath
                        window.open(res.pdfPath, "_blank");
                        this.quotationloader = this.globalService.spinnerHide();

                    })
                } else if (type == 4) {
                    this.isToBeReferred = this.CheckReferralConditions();
                    if (this.isToBeReferred) {
                        this.refferalButton = true;

                        Swal.fire("Thank you for you request, based on your application details, the case needs to be referred to UW team for further review.Please click 'Refer A Quote' Button down", "If you need further assistance call us at 800-842", "error");
                        return false;
                    }
                    this.quotationloader = this.globalService.spinnerHide();
                    let QuoteArray = [{
                        productCode: this.productCode,
                        lob_code: 'SM',
                        processType: 'INSERT',
                        policyType: 'NEW',
                        source: 'B2B'
                    }]
                    if (this.emailAdd == '' || null) {
                        this.emailaddValidation = true;
                        return false;
                    } else {
                        let QuoteArray = [{
                            productCode: this.productCode,
                            lob_code: 'SM',
                            processType: 'INSERT',
                            policyType: 'NEW',
                            source: 'B2B'
                        }]
                        this.smequoteService.printsmepdf(QuoteArray, this.quoteNumber).subscribe(res => {
                            // alert('1');
                            //         // res.pdfPath
                            //         window.open( res.pdfPath, "_blank");
                            //         this.quotationloader=this.globalService.spinnerHide();

                        })
                        this.emailaddValidation = false;
                        this.smequoteService.emailSMEquote(QuoteArray, this.quoteNumber, this.emailAdd).subscribe(res => {



                            if (res.response_code == 1) {
                                Swal.fire("", "Thank you for choosing Fidelity United for SME. We have sent an email to your registered email with all the quotation details. Your Quotation Reference# " + this.quoteNumber, 'success');
                            }
                            // res.pdfPath
                            // window.open( res.pdfPath, "_blank");
                            // this.quotationloader=this.globalService.spinnerHide();

                        })

                    }

                } else {

                    this.quotationloader = this.globalService.spinnerHide();

                }


            })

        }

    }

    saveChanges() {


        this.upliftref = 0;
        this.cvref = 0;
        this.pespref = 0;
        this.cpmref = 0
        this.tfref = 0;
        this.drref = 0;

        if (this.basePremium[this.currentIndex] == 0) {
            Swal.fire("", "Basic Premium cannot be 0", 'error');
            return;
        }

        this.benefitData.forEach((locationElement, locindex) => {
            locationElement.sections.forEach((section, index) => {
                section.covers.forEach((element, coverindex) => {
                    let suminsured = element.DefaultSumCovered != 0 ? element.DefaultSumCovered.replace(/,/gi, "") : 0
                    this.totalSumInsured[locindex] = +parseInt(suminsured)
                })
            })
        })


        this.benefitData.forEach((locationElement, locindex) => {
            locationElement.sections.forEach((section, index) => {
                section.covers.forEach((element, coverindex) => {

                    if (element.BenefitName == 'Contract Value') {
                        if (element.DefaultSumCovered != 0) {
                            this.cv[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.cv[locindex] = 0;
                        }
                    }
                    if (element.BenefitName == 'Principal Existing and Surrounding Properties (PESP Value)') {
                        if (element.DefaultSumCovered != 0) {
                            this.pesp[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.pesp[locindex] = 0;
                        }
                    }
                    if (element.BenefitName == 'Contractors Plant and Machineries (CPM Value)') {
                        if (element.DefaultSumCovered != 0) {
                            this.cpm[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.cpm[locindex] = 0;
                        }
                    }
                    if (element.BenefitName == 'Temporary Facilities') {
                        if (element.DefaultSumCovered != 0) {
                            this.tf[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.tf[locindex] = 0;
                        }
                    }
                    if (element.BenefitName == 'Debris Removal') {
                        if (element.DefaultSumCovered != 0) {
                            this.dr[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.dr[locindex] = 0;
                        }
                    }
                    if (element.BenefitName == 'Uplift Value') {
                        if (element.DefaultSumCovered != 0) {
                            this.uv[locindex] = +element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.uv[locindex] = 0;
                        }
                    }
                    this.totalcar[locindex] = this.cv[locindex] + this.pesp[locindex] + this.cpm[locindex] + this.tf[locindex] + this.dr[locindex] + this.uv[locindex];
                })

            })
        })

        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR') && (this.uv[this.currentIndex] > 0.1 * (this.cv[this.currentIndex])))

            )) {
            this.upliftref = 1;
        }

        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR') && (this.cv[this.currentIndex] > 40000000))

            )) {
            this.cvref = 1;
        }


        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR') && (this.pesp[this.currentIndex] > 5000000))

            )) {
            this.pespref = 1;
        }

        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR') && (this.cpm[this.currentIndex] > 500000))

            )) {
            this.cpmref = 1;
        }

        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR' )&& (this.tfref[this.currentIndex] > 500000))

            )) {
            this.tfref = 1;
        }

        if (this.IsRenewal == 0 &&
            (
                // (this.productId == 'SMEPAR' && this.covermustpar[this.currentIndex] && (this.totalcar[this.currentIndex] == 0 ) && ((this.totalcar[this.currentIndex] -  this.uv[this.currentIndex]) <= 0)) ||
                ((this.productId == 'SMECPM' || this.productCode == 'SMEEAR' )&& (this.dr[this.currentIndex] > 500000))

            )) {
            this.drref = 1;
        }

        this.businessPackageModel = false;

    }

    convertDate(inputFormat) {
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }
        var d = new Date(inputFormat);
        // console.log([ pad(d.getMonth()+1),pad(d.getDate()),d.getFullYear()])
        return ([pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/'));

    }
    checkTermsCond() {
        this.accept_terms = !this.accept_terms;
    }
    checkDisclaimer() {
        this.accept_disclaimer = !this.accept_disclaimer;
    }
    // checkissuepolicy(type){
    //     //IA license and Trade license validate starts..
    //   // this.getBrokerLicenseDetails().then(validLicense=>{
    //   //   if(validLicense){
    //     //DIGI Status check starts Feb2024

    //     this.digi_status$.subscribe(trackText => {
    //       //this.digiSwalInstance= Swal.fire(`<b>SME Insurance Policy</b>`,`${trackText}`,"success")
    //       this.digiSwalInstance= Swal.fire({
    //         title: '',
    //         html: `<div style="display: inline-block;margin-top:40px; vertical-align: middle; height: 50px; width: 430px;">${trackText}</div>`,  
    //         showConfirmButton: false
    //       });
    //     });

    //     var digiRequest={
    //       "QuotationNumber":this.quoteNumber,
    //       "FirstName": this.smeQuoteDetails.get('businessName').value,
    //       "MiddleName": "",
    //       "LastName": this.smeQuoteDetails.get('businessName').value,
    //       "MatchCategory": "C",
    //       "Nationality": "",
    //       "DOB": "",
    //       "CustomerType": "C",
    //       "UserEmail": this.localStorDta.EmailAddress
    //     };
    //     this.issuepolicyLoader=this.globalService.spinnerShow();
    //   this.issuepolicyService.GetDIGIStatus(digiRequest).subscribe(res=>{
    //     this.issuepolicyLoader=this.globalService.spinnerHide();
    //     if(res==null ||res.data==null ){
    //    Swal.fire("", "Failed to process the request. Please try again", 'error'); 
    //     return;
    //     }
    //       else if(res.data.digiStatus=='Approved' ){
    //       if (this.digiSwalInstance) {
    //         this.digiSwalInstance.close();
    //        }
    //        this.docUploadFlag = true;     
    //        this.issuePolicy(type);
    //       return;
    //     }

    //     else {   

    //        if(config.enableDIGIApproval=="N"){
    //         this.digi_status.next("Almost there...");
    //         setTimeout(() => {
    //           this.digi_status.next("Please do not close the browser or refresh...");
    //       }, 2000);
    //         setTimeout(() => {
    //           if (this.digiSwalInstance) {
    //             this.digiSwalInstance.close();
    //            }
    //           this.docUploadFlag = true;     
    //           this.issuePolicy(type);
    //       }, 60000); 
    //      }  
    //      else {
    //       if (this.digiSwalInstance) {
    //         this.digiSwalInstance.close();
    //        }
    //       Swal.fire("", "KYC verification is in progress. You will be receiving a confirmation email to proceed", 'warning'); 
    //       return;  
    //    }

    //     }
    //     // else{
    //     //   if(res.data.recordExists==true){
    //     //     Swal.fire("DIGI Approval Requested already", "You will be receiving a confirmation mail from compliance", 'error').then(result => {
    //     //       this._route.navigateByUrl('home/retreivequote');
    //     //     });
    //     //   }
    //     //    else{
    //     //     Swal.fire("DIGI Approval Requested", "You will be receiving a confirmation mail from compliance", 'error').then(result => {
    //     //       this._route.navigateByUrl('home/retreivequote');
    //     //     });
    //     //    }

    //     // }
    //   });
    //    //DIGI Status check End Feb2024
    //     // }
    //     // });
    // }

    checkissuepolicy(type) {
        //IA license and Trade license validate starts..
        // this.getBrokerLicenseDetails().then(validLicense=>{
        //   if(validLicense){
        this.docUploadFlag = true;
        this.issuePolicy(type);
        // }
        // });
    }


    issuePolicy(type) {
        console.log(type)
        console.log(this.docList)
        // console.log(this.docUploadFlag);
        this.additionalDetails.controls.forEach((locElement, locIndex) => {
            console.log("Checking at", this.docList[locIndex])
            this.docList[locIndex].forEach((element, index) => {
                if (this.docUploadFlag == true) {
                    if (element.MandatorySymbol == '*') {
                        if (element.UploadedFileName == '') {
                            this.docUploadFlag = false;
                        } else {
                            this.docUploadFlag = true;
                        }
                    }
                }
            });
        });
        this.docListpol.forEach((element, index) => {
            if (this.docUploadFlag == true) {
                if (element.MandatorySymbol == '*') {
                    if (element.UploadedFileName == '') {
                        this.docUploadFlag = false;
                    } else {
                        this.docUploadFlag = true;
                    }
                }
            }
        });

        // if(this.docUploadFlag == false){
        //   Swal.fire("", "Please Upload Required Documents", 'error');
        //   return;
        // }
        if (this.additionalDetailForm.invalid) {
            console.log(this.additionalDetailForm)
            this.additionalDetailForm.markAllAsTouched();
            this.additionalDetailForm.updateValueAndValidity();
            Swal.fire("", "Please fill all the mandatory data", 'error');
            return;

        } else if (this.docUploadFlag == false) {
            Swal.fire("", "Please Upload Required Documents", 'error');
            return;
        } else if (this.accept_terms == false) {
            Swal.fire("", "Please Select Terms And Conditions", 'error');
            return;
        } else if (this.accept_disclaimer == false) {
            Swal.fire("", "Please accept Disclaimer", 'error');
            return;
        }
        this.issuepolicyLoader = this.globalService.spinnerShow();
        let savePolicy = []
console.log("before issuance",this.benefitData);
        this.additionalDetailForm.value.additionalDetails.map((x, i) => {
            savePolicy.push({
                CompanyName: this.smeQuoteDetails.value.businessName.replace(this.characterToReplace, this.replacementCharacter),
                ContactPerson: x.contactperson,
                MortgageeText1: x.mortgagee1,
                MortgageeText2: x.mortgagee2,
                BankDetails: x.bankDetails,
                LegalStatus: this.additionalDetailForm.value.legalstatus,
                AssignmentValue: x.assignmentValue,
                RegistrationNumber: x.tradeLicNumber,
                TRNNumber: x.trnNo,
                RiskLocation: x.companyAddress,
                POBox: x.poboxNo,
                PhoneNumber: x.phoneNumber,
                MobileNumber: x.mobNo,
                EmailAddress: x.email,
                FreeZone: x.freezzone.value,
                CoverStartDate: this.convertDate(this.additionalDetailForm.value.CoverStartDate),
                PartnerId: this.smeQuoteDetails.value.partner,
                UserId: this.userId,
                FixedPlanContribution: this.benefitData[0].locationBasePremium,
                FixedPlanId: this.planId,
                ServiceTax: this.serviceTax,
                ServiceTaxRate: 0,
                policyFee: this.policyFee,
                TotalContribution: this.totalPremium,
                VATAmount: this.Vat_Amount,
                VATTaxRate: 5,
                PremLoading: this.loadingAmount,
                PremLoadingRate: this.loadingby,
                PremDiscount: this.discountAmount,
                PremDiscountRate: this.discountby,
                ProductCode: this.productCode,
                QuotationNumber: this.quoteNumber,
                PlanId: this.planId,
                CurrencyCode: 'AED',
                source: 'B2B',
                AddressLatitude: this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[0].trim().slice(0, 19) : '',
                AddressLongitude: this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[1].trim().slice(0, 19) : ''

            })


        })

        //Added by Anju for party status active check on Issue Policy/Pay Now/Send Payment Link
        this.selectedPartnerId = this.smeQuoteDetails.value.partner;
        this.selectedBranchId = this.smeQuoteDetails.value.branch.Id;
        console.log('calling smequoteService.smesavePolicy savePolicy:' + JSON.stringify(savePolicy))
        console.log('calling smequoteService.smesavePolicy type:' + type)
        this.smequoteService.checkPartner_CreditLimit("Property All Risk", 0, this.selectedPartnerId, this.selectedBranchId).subscribe(response => {
            if (response.cl_status == '200012') {
                Swal.fire('Party is not Active.');
                this.issuepolicyLoader = this.globalService.spinnerHide();
            } else {
                if (type == 1) {
                    //DIGI Status check starts Feb2024
                    this.digi_status$.subscribe(trackText => {
                        //this.digiSwalInstance= Swal.fire(`<b>SME Insurance Policy</b>`,`${trackText}`,"success")
                        this.digiSwalInstance = Swal.fire({
                            title: '',
                            html: `<div style="display: inline-block;margin-top:40px; vertical-align: middle; height: 50px; width: 430px;">${trackText}</div>`,
                            showConfirmButton: false
                        });
                    });

                    var digiRequest = {
                        "QuotationNumber": this.quoteNumber,
                        "FirstName": this.smeQuoteDetails.get('businessName').value,
                        "MiddleName": "",
                        "LastName": this.smeQuoteDetails.get('businessName').value,
                        "MatchCategory": "C",
                        "Nationality": "",
                        "DOB": "",
                        "CustomerType": "C",
                        "UserEmail": this.localStorDta.EmailAddress
                    };
                    this.issuepolicyLoader = this.globalService.spinnerShow();
                    this.issuepolicyService.GetDIGIStatus(digiRequest).subscribe(res => {
                        this.issuepolicyLoader = this.globalService.spinnerHide();
                        if (res == null || res.data == null) {
                            Swal.fire("", "Failed to process the request. Please try again", 'error');
                            return;
                        } else if (res.data.digiStatus == 'Approved') {
                            this.smequoteService.smeissuePolicy(savePolicy).subscribe(res => {
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                if (res.res_code == 1) {
                                    this.policyNumber = res.policy_details[0].PolicyNumber;
                                    this.getCreditDebitNote();
                                    this.issuepolicyLoader = this.globalService.spinnerHide();
                                    this._route.navigateByUrl("sme/thankyou/" + this.policyNumber + '/' + this.quoteNumber);
                                }
                            });
                        } else {
                            if (config.enableDIGIApproval == "N") {
                                this.digi_status.next("Almost there...");
                                setTimeout(() => {
                                    this.digi_status.next("Please do not close the browser or refresh...");
                                }, 2000);
                                setTimeout(() => {
                                    this.smequoteService.smeissuePolicy(savePolicy).subscribe(res => {
                                        debugger;
                                        if (this.digiSwalInstance) {
                                            this.digiSwalInstance.close();
                                        }
                                        if (res.res_code == 1) {
                                            this.policyNumber = res.policy_details[0].PolicyNumber;
                                            this.getCreditDebitNote();
                                            this.issuepolicyLoader = this.globalService.spinnerHide();
                                            this._route.navigateByUrl("sme/thankyou/" + this.policyNumber + '/' + this.quoteNumber);
                                        }
                                    });
                                }, 60000);
                            } else {
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                Swal.fire("", "KYC verification is in progress. You will be receiving a confirmation email to proceed", 'warning');
                                return;
                            }

                        }
                    });
                }
                if (type == 2) {
                    //DIGI Status check starts Feb2024
                    this.digi_status$.subscribe(trackText => {
                        //this.digiSwalInstance= Swal.fire(`<b>SME Insurance Policy</b>`,`${trackText}`,"success")
                        this.digiSwalInstance = Swal.fire({
                            title: '',
                            html: `<div style="display: inline-block;margin-top:40px; vertical-align: middle; height: 50px; width: 430px;">${trackText}</div>`,
                            showConfirmButton: false
                        });
                    });

                    var digiRequest = {
                        "QuotationNumber": this.quoteNumber,
                        "FirstName": this.smeQuoteDetails.get('businessName').value,
                        "MiddleName": "",
                        "LastName": this.smeQuoteDetails.get('businessName').value,
                        "MatchCategory": "C",
                        "Nationality": "",
                        "DOB": "",
                        "CustomerType": "C",
                        "UserEmail": this.localStorDta.EmailAddress
                    };
                    this.issuepolicyLoader = this.globalService.spinnerShow();
                    this.issuepolicyService.GetDIGIStatus(digiRequest).subscribe(res => {
                        this.issuepolicyLoader = this.globalService.spinnerHide();
                        if (res == null || res.data == null) {
                            Swal.fire("", "Failed to process the request. Please try again", 'error');
                            return;
                        } else if (res.data.digiStatus == 'Approved') {
                            this.smequoteService.smesavePolicy(savePolicy).subscribe(res => {
                                debugger;
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                this.policyNumber = res.quote_details[0].PolicyNumber;
                                if (res.res_code == 1) {
                                    let return_url = "http://localhost:4200/dashboard";
                                    let site_url = "http://localhost:4200/" + this._route.url;
                                    this.travelInsuranceService.paymentAuth(this.quoteNumber, site_url, return_url, 'SM', this.partnerID, this.policyNumber, 'SHIELD', 'B2B').subscribe(res => { //Added by Anju for SME Payment gateway revamp
                                        if (res.status == 'Failed') {
                                            Swal.fire(res.res_msg);
                                            this.issuepolicyLoader = this.globalService.spinnerHide();

                                            return false;
                                        } else if (res.status == 'Success') {

                                            // this.policyLoader = this.globalService.spinnerHide();
                                            localStorage.setItem('Payment_Order_ID', res.data.tran_ref);
                                            localStorage.setItem('Payment_Order_Tokan', res.data.token);
                                            localStorage.setItem('Payment_Quotation_Number', this.quoteNumber);
                                            localStorage.setItem('Payment_Quotation_ID', this.quoteId);
                                            window.location.href = res.data.redirect_url;
                                            // window.open(res.result.redirect_url, '_blank');


                                        }

                                    })
                                }
                            })
                        } else {
                            if (config.enableDIGIApproval == "N") {
                                this.digi_status.next("Almost there...");
                                setTimeout(() => {
                                    this.digi_status.next("Please do not close the browser or refresh...");
                                }, 2000);
                                setTimeout(() => {
                                    this.smequoteService.smesavePolicy(savePolicy).subscribe(res => {
                                        if (this.digiSwalInstance) {
                                            this.digiSwalInstance.close();
                                        }
                                        this.policyNumber = res.quote_details[0].PolicyNumber;
                                        if (res.res_code == 1) {
                                            let return_url = "http://localhost:4200/dashboard";
                                            let site_url = "http://localhost:4200/" + this._route.url;
                                            this.travelInsuranceService.paymentAuth(this.quoteNumber, site_url, return_url, 'SM', this.partnerID, this.policyNumber, 'SHIELD', 'B2B').subscribe(res => { //Added by Anju for SME Payment gateway revamp
                                                if (res.status == 'Failed') {
                                                    Swal.fire(res.res_msg);
                                                    this.issuepolicyLoader = this.globalService.spinnerHide();

                                                    return false;
                                                } else if (res.status == 'Success') {

                                                    // this.policyLoader = this.globalService.spinnerHide();
                                                    localStorage.setItem('Payment_Order_ID', res.data.tran_ref);
                                                    localStorage.setItem('Payment_Order_Tokan', res.data.token);
                                                    localStorage.setItem('Payment_Quotation_Number', this.quoteNumber);
                                                    localStorage.setItem('Payment_Quotation_ID', this.quoteId);
                                                    window.location.href = res.data.redirect_url;
                                                    // window.open(res.result.redirect_url, '_blank');


                                                }

                                            })
                                        }
                                    })
                                }, 60000);
                            } else {
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                Swal.fire("", "KYC verification is in progress. You will be receiving a confirmation email to proceed", 'warning');
                                return;
                            }

                        }
                    });
                }
                if (type == 3) {
                    //DIGI Status check starts Feb2024
                    this.digi_status$.subscribe(trackText => {
                        //this.digiSwalInstance= Swal.fire(`<b>SME Insurance Policy</b>`,`${trackText}`,"success")
                        this.digiSwalInstance = Swal.fire({
                            title: '',
                            html: `<div style="display: inline-block;margin-top:40px; vertical-align: middle; height: 50px; width: 430px;">${trackText}</div>`,
                            showConfirmButton: false
                        });
                    });

                    var digiRequest = {
                        "QuotationNumber": this.quoteNumber,
                        "FirstName": this.smeQuoteDetails.get('businessName').value,
                        "MiddleName": "",
                        "LastName": this.smeQuoteDetails.get('businessName').value,
                        "MatchCategory": "C",
                        "Nationality": "",
                        "DOB": "",
                        "CustomerType": "C",
                        "UserEmail": this.localStorDta.EmailAddress
                    };
                    this.issuepolicyLoader = this.globalService.spinnerShow();
                    this.issuepolicyService.GetDIGIStatus(digiRequest).subscribe(res => {
                        this.issuepolicyLoader = this.globalService.spinnerHide();
                        if (res == null || res.data == null) {
                            Swal.fire("", "Failed to process the request. Please try again", 'error');
                            return;
                        } else if (res.data.digiStatus == 'Approved') {
                            this.smequoteService.smesavePolicy(savePolicy).subscribe(res => {
                                debugger;
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                this.motorQuoteService.sendPaymentLink(this.quoteNumber, 'SM', this.additionalDetailForm.value.email, 'B2B', '', this.smeQuoteDetails.value.partner).subscribe(res => {

                                    let payRes = res;

                                    if (payRes.res_code == 1) {

                                        Swal.fire('', 'Payment link has been sent to customer for the reference no. ' + this.quoteNumber, 'success');

                                        this._route.navigate(['sme/products']);

                                    }
                                    // this.showLoader.Quotation = false;
                                });
                            })
                        } else {
                            if (config.enableDIGIApproval == "N") {
                                this.digi_status.next("Almost there...");
                                setTimeout(() => {
                                    this.digi_status.next("Please do not close the browser or refresh...");
                                }, 2000);
                                setTimeout(() => {
                                    this.smequoteService.smesavePolicy(savePolicy).subscribe(res => {
                                        if (this.digiSwalInstance) {
                                            this.digiSwalInstance.close();
                                        }
                                        this.motorQuoteService.sendPaymentLink(this.quoteNumber, 'SM', this.additionalDetailForm.value.email, 'B2B', '', this.smeQuoteDetails.value.partner).subscribe(res => {

                                            let payRes = res;

                                            if (payRes.res_code == 1) {

                                                Swal.fire('', 'Payment link has been sent to customer for the reference no. ' + this.quoteNumber, 'success');

                                                this._route.navigate(['sme/products']);

                                            }
                                            // this.showLoader.Quotation = false;
                                        });
                                    })
                                }, 60000);
                            } else {
                                if (this.digiSwalInstance) {
                                    this.digiSwalInstance.close();
                                }
                                Swal.fire("", "KYC verification is in progress. You will be receiving a confirmation email to proceed", 'warning');
                                return;
                            }

                        }
                    });
                }
            }
        });
    }
    //------------------------- CHECK USER ACCESS FOR PAGE ------------------------------------//
    checkUserAccess() {
        this.motorQuoteService.checkUserAccess('SMEQUOTE', this.localStorDta.EmailAddress, 'SM').subscribe(res => {
            let response = res;

            if (response.userAccessData == 0) { // userAccessData = 1 ------ give access 
                Swal.fire('Sorry !', 'You can not authorised.', 'error');
                this._route.navigateByUrl('/agentMotor/motorquote'); // userAccessData = 0 ------- access denied
                this.userAccess = false;
                return false;
            } else {

                this.userAccess = true;
            }
        });
    }

    getCreditDebitNote() {
        this.smequoteService.creditDebitNote("B2B", this.policyNumber).subscribe(res => {})

    }
    annualBusinessChange(item) {
        if (item.AnnualTurnover != 'Less than AED 400,000 per year') {
            this.additionalDetailForm.controls['trnNo'].setValidators([Validators.required]);
            this.additionalDetailForm.controls['trnNo'].updateValueAndValidity()

        } else {
            this.additionalDetailForm.controls['trnNo'].setValidators(null);
            this.additionalDetailForm.controls['trnNo'].updateValueAndValidity()
        }
    }

    checkNumber(value, type) {
        const min = this.minLoadingRange;
        const max = this.maxLoadingRange;

        // Convert the value to a number
        let numericValue = parseFloat(value);

        // Check if the value is a valid number and within the min/max range
        if (!isNaN(numericValue)) {
            if (numericValue < min) {
                this.loadingby = min.toString(); // Set to min value
            } else if (numericValue > max) {
                this.loadingby = max.toString(); // Set to max value
            }
        } else {
            // If input is not a valid number, clear the input or handle as needed
            this.loadingby = '';
        }
        // console.log(value)
        if (numericValue > this.maxLoadingRange) {
            this.loadingby = this.maxLoadingRange
        }

        if (type == 'loading')
            this.getLoadingBy();
        else {
            this.getDiscountBy()
        }
    }

    uploadCompanyDocument(event, i, docindex, item) {
        let locationId = parseInt(i) + 1;
        let AllowedExtensions = item.AllowedExtensions.replaceAll(/\s/g, '');
        this.access = 1;
        const formData = new FormData();

        //  console.log(event.target.files[0].name);
        let ourEx = event.target.files[0].name.split('.')
        console.log(ourEx);
        // console.log(ourEx[1]);
        if ((ourEx[1] == 'xls' || ourEx[1] == 'xlsx') && item.DocumentId == 155) {
            this.docList[i][docindex].checked = true;
            this.docList[i][docindex].file_name = event.target.files[0].name
            this.docList[i][docindex].UploadedFileName = event.target.files[0].name
            formData.append('file', event.target.files[0]);
            formData.append('LOBCode', 'SM');
            formData.append('QuotationNumber', this.quoteNumber);
            formData.append('FileExtn', ourEx[1]);
            formData.append('LocationId', locationId.toString())
            this.smequoteService.uploadDocumentsXls(formData).subscribe(result => {
                event.target.value = null;
                if (result.response_code == 2) {
                    Swal.fire("Please select valid file format.", "", 'error');
                    this.docList[i][docindex].file_name = '';
                    this.docList[i][docindex].UploadedFileName = '';
                    this.docList[i][docindex].checked = false;
                }

                this.benefitData[i].forEach((element, index) => {
                    if (element.BenefitName == 'As per UAE Labour Law with estimated annual wages not exceeding') {
                        if (element.DefaultSumCovered != 0) {
                            this.totalsalary = element.DefaultSumCovered.replace(/,/gi, "");
                        } else {
                            this.totalsalary = 0;
                        }
                    }
                })

                console.log(this.totalsalary)

                if (Number(result.total_salary) != Number(this.totalsalary)) {
                    Swal.fire("Mismatch between annual wages on portal and the excel template, please correct the values.", "", 'error');
                    this.docList[i][docindex].file_name = '';
                    this.docList[i][docindex].UploadedFileName = '';
                    event.target.value = null;
                    this.docList[i][docindex].checked = false;
                    this.smequoteService.deleteEmployeeList(this.quoteNumber, locationId).subscribe(result => {
                        console.log(result);
                    });
                }
                // console.log(result);
            })

        } else {
            formData.append('DocumentName', this.docListpol[docindex].DocumentName);
            formData.append('file', event.target.files[0]);
            // console.log(event.target.files[0]);
            // let allowedEx =event.target.files[0].name.split(',');
            formData.append('LOBCode', 'SM');
            formData.append('QuotationNumber', this.quoteNumber);
            formData.append('FileExtn', ourEx[1]);
            formData.append('LocationId', locationId.toString())
            let allowedEx = AllowedExtensions.split(',');
            // console.log(allowedEx);
            // console.log('.'+ourEx[1].trim  ())

            allowedEx.forEach((element, index) => {
                if (this.access == 1) {
                    // console.log((allowedEx[index]).toLowerCase());
                    // console.log('.'+(ourEx[1].trim()).toLowerCase());
                    if ((allowedEx[index]).toLowerCase() == '.' + (ourEx[1].trim()).toLowerCase()) {
                        this.access = 0;
                    } else {
                        this.access = 1;
                    }
                }

            });

            if (this.access == 1) {
                Swal.fire("Please select valid file format.", "", 'error');
                return false;
            }
            this.smequoteService.uploadDocuments(formData).subscribe(result => {
                console.log(result.response_code);
                if (result.response_code == 1) {
                    this.docListpol[docindex].checked = true;
                    this.docListpol[docindex].UploadedFileName = result.image_url;
                    this.docListpol[docindex].file_name = event.target.files[0].name;

                    // this.companydocument = result.image_url;
                    // this.documentCheckbox = true;
                } else if (result.response_code == 3) {
                    Swal.fire("Allowed upload file size is up to 2MB", "", 'error');
                    this.docListpol[docindex].file_name = '';
                    this.docListpol[docindex].checked = false;
                    // this.companydocument = '';
                    // this.documentCheckbox = false;
                } else if (result.response_code == 5) {
                    Swal.fire("Please select valid file format.", "", 'error');
                    this.docListpol[docindex].file_name = '';
                    this.docListpol[docindex].checked = false;
                    // this.companydocument = '';
                    // this.documentCheckbox = false;
                } else {
                    this.docListpol[docindex].checked = false;
                }

            })

        }
        console.log("Documenyt", this.docList)


    }
    uploadAddinfoDocument(event, i) {
        this.access = 1;
        const formData = new FormData();
        //  console.log(event.target.files[0].name);
        let ourEx = event.target.files[0].name.split('.')
        console.log(ourEx);
        formData.append('DocumentName', 'Additional_Doc');
        formData.append('file', event.target.files[0]);
        console.log(event.target.files[0]);
        // let allowedEx =event.target.files[0].name.split(',');
        formData.append('LOBCode', 'SM');
        formData.append('QuotationNumber', this.quoteNumber);
        formData.append('FileExtn', ourEx[1]);

        this.smequoteService.uploadDocuments(formData).subscribe(result => {
            console.log(event.target.files[0].name);
            this.response_code = result.response_code;
            if (result.response_code == 1) {
                this.UploadedFileName = result.image_url;
                this.file_name = event.target.files[0].name;
            } else if (result.response_code == 3) {
                Swal.fire("Allowed upload file size is up to 2MB", "", 'error');
                event.target.value = null;
                this.file_name = '';
            } else if (result.response_code == 5) {
                Swal.fire("Please select valid file format.", "", 'error');
                event.target.value = null;
                this.file_name = '';
            } else {
                event.target.value = null;
                this.file_name = '';
            }

        })
    }

    uploadAddinfoDocument2(event, type: string) {
        this.access = 1;
        const formData = new FormData();
        //  console.log(event.target.files[0].name);
        let ourEx = event.target.files[0].name.split('.')
        console.log(ourEx);
        formData.append('DocumentName', 'Additional_Doc');
        formData.append('file', event.target.files[0]);
        console.log(event.target.files[0]);
        // let allowedEx =event.target.files[0].name.split(',');
        formData.append('LOBCode', 'SM');
        formData.append('QuotationNumber', this.quoteNumber);
        formData.append('FileExtn', ourEx[1]);

        this.smequoteService.uploadDocuments(formData).subscribe(result => {
            console.log(event.target.files[0].name);
            this.response_code = result.response_code;
            if (result.response_code == 1) {
                if (type === 'claimDocument') {
                    this.claimFileName = event.target.files[0].name;
                    // Update response code and uploaded file name accordingly
                    this.claimResponseCode = '1'; // Simulating a successful upload
                    this.uploadedClaimFileName = result.image_url; // Set your file path here
                } else if (type === 'additionalDocument') {
                    this.otherFileName = event.target.files[0].name;
                    // Update response code and uploaded file name accordingly
                    this.otherResponseCode = '1'; // Simulating a successful upload
                    this.uploadedOtherFileName = result.image_url; // Set your file path here
                    const additionalDocFile = {
                        fileName: event.target.files[0].name,
                        fileType: ourEx[1],
                        fileURL: result.image_url
                    };
                    this.additionalDocFiles.push(additionalDocFile);
                }

            }

            // if(result.response_code == 1){
            //  // this.UploadedFileName =result.image_url;
            //  // this.file_name =event.target.files[0].name;
            // }
            else if (result.response_code == 3) {
                Swal.fire("Allowed upload file size is up to 2MB", "", 'error');
                event.target.value = null;
                this.file_name = '';
            } else if (result.response_code == 5) {
                Swal.fire("Please select valid file format.", "", 'error');
                event.target.value = null;
                this.file_name = '';
            } else {
                event.target.value = null;
                this.file_name = '';
            }

        })
    }

    triggerFileInput(type ? : string) {
        // Logic to open file input for uploading additional documents
        const fileInput = document.getElementById(type);
        if (fileInput) {
            fileInput.click();
        }
    }
    // triggerFileInput() {
    //   const fileInput = document.getElementById('additionalDocumentInput') as HTMLInputElement;
    //   if (fileInput) {
    //     fileInput.click(); // Programmatically click the file input when "+" is pressed
    //   }
    // }

    handleAdditionalDocument(event: any) {
        const file = event.target.files[0];
        if (file) {
            // Call the modified upload function with type 'additionalDocument'
            this.uploadAddinfoDocument2(event, 'additionalDocument');
        }
    }
    handleAdditionalDocument2(event: any) {
        let ourEx = event.target.files[0].name.split('.')
        const additionalDocFile = {
            fileName: event.target.files[0].name,
            fileType: ourEx[1],
            fileURL: event.target.files[0].name
        };
        this.additionalDocFiles.push(additionalDocFile);
        this.uploadAddinfoDocumentinScreen = true;
        this.event = event

    }
    termsAndConditions(frame) {

        frame.show();

    }

    // ---------------------------------------------Range For Loading & Discount-----------------------------------------------

    discountRange() {
        this.homeQuoteService.getPlanLoadingDiscount(this.productCode, 'SM', this.smeQuoteDetails.value.partner, '1', 'ENG').subscribe(
            result => {
                console.log(result);
                this.minLoadingRange = result.getPlanLoadingDiscount[0].PLAmount;
                this.maxLoadingRange = result.getPlanLoadingDiscount[0].PLPercent;
                this.loadingby = this.minLoadingRange;

            })

    }

    getReferalCondtion(ref_val) {
        // alert(1)

        this.ref_value = ref_val;
        this.saveChanges()

        this.referalModel = true;

        if (ref_val == 'APPROVED') {
            this.refer_type = 'Approve';
            this.refer_condtion_type = 3;
        }

        if (ref_val == 'REJECTED') {
            this.refer_type = 'Reject';
            this.refer_condtion_type = 4;
        }

        if (ref_val == 'REFERRAL') {
            if (this.quoteNumber == '') {
                this.refQuotation();
            }
            this.refer_type = 'Refer';
            this.refer_condtion_type = 2;
        }
        if (ref_val == 'REFASSIGN') {
            if (this.quoteNumber == '') {
                this.refQuotation();
            }
            this.refer_type = 'Refer';
            this.refer_condtion_type = 1;
        }

        if (ref_val == 'ADDITIONALINFO') {
            this.refer_type = 'Additional Info';
            this.refer_condtion_type = 5;
        }

    }

    // -------------------------------------------------Referal ---------------------------------------------------------

    sendRefferMailToAdmin(type, refReason, frame) {
        this.refquotationloader = this.globalService.spinnerShow();
        this.saveQuotePlanDetail('', 0)
        console.log(refReason)
        if (type == 1) {
            this.validtnMsg = false;
            this.referal = true;
            //update the Quotation details table 
        }
        if (type == 2) {
            // alert(1)
            if (this.referalDescription == '') {
                // alert(2)
                this.validtnMsgfordescription = true;
                return false;
            }
            this.validtnMsg = false;
            this.referal = true;
        }

        if (type == 3 || type == 4 || type == 5) {
            if (this.referalDescription == '') {
                this.validtnMsgfordescription = true;
                return false;
            }
            this.validtnMsgfordescription = false;
            this.referal = true;
        }


        let refer_type;
        let event_type;

        if (type == 1) {
            event_type = 'REFASSIGN'; // REFER A QUOTE
            refer_type = type == 1 ? 'SYSTEM' : 'MANUAL';
            this.policyStatus = 'REFERED';
            this.RefAssignedUserName = this.RefAssignedTo
            this.RefAssignedTo = 'Pending with UW ' + this.RefAssignedTo

        }
        if (type == 2) {
            event_type = 'REFERQUOTE'; // REFER A QUOTE
            refer_type = type == 1 ? 'SYSTEM' : 'MANUAL';
            this.policyStatus = 'REFERED';
        }

        if (type == 3) {
            event_type = 'REFERAPPROVED'; // APPROVED
            refer_type = '';
            this.policyStatus = 'APPROVED';
            this.RefAssignedTo = '';
        }

        if (type == 4) {
            event_type = 'REFERREJECTED'; // REJECTED
            refer_type = '';
            this.policyStatus = 'REJECTED';
        }

        if (type == 5) {
            event_type = 'ADDITIONALINFO';
            if (this.businessSource == 'DIRECT' && this.partnerID == 1 && this.userType == 'POS' && (this.userRole == 'TELEMARKETING' || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.quoteStatus == 'REFERRED') {
                this.RefAssignedTo = 'Pending with Broker' // ADDITIONAL INFO
            } else {
                this.RefAssignedTo = 'Pending with UW team' // ADDITIONAL INFO
            }
            refer_type = '';
            this.policyStatus = 'ADDITIONALINFO';
        }
        // console.log(type)
        // console.log(refer_type)
        this.smequoteService.getReferal(this.quoteNumber, refReason, this.referalDescription, event_type, refer_type, this.additionalDocFile, '', this.RefAssignedTo, this.RefAssignedUserName).subscribe(res => {

            if (res.response_code == 1) {
                this.refquotationloader = this.globalService.spinnerHide();
                if (type == 1) {
                    this.referal = false;

                }
                if (type == 1) {
                    this.referal = false;
                    Swal.fire('Your quote has been re-assigned to our expert team of UWs for review.', 'You will be notified soon after the review. Your Quotation Reference# ' + this.quoteNumber, 'success');
                    this._route.navigate(['sme/products']);
                }

                if (type == 2) {
                    this.referal = false;
                    Swal.fire('Your quote has been referred to our expert team of UWs for review.', 'You will be notified soon after the review. Your Quotation Reference# ' + this.quoteNumber, 'success');
                    this._route.navigate(['sme/products']);
                }

                if (type == 3) {
                    Swal.fire('The quote has been successfully approved for the Quotation Number: ' + this.quoteNumber);
                    this._route.navigate(['home/referalquote']);
                }
                if (type == 4) {
                    Swal.fire('The quote has been Rejected for the Quotation Number: ' + this.quoteNumber);
                    this._route.navigate(['home/referalquote']);
                }
                if (type == 5) {
                    if ((this.userRole == "TELEMARKETING" || this.userRole == 'UW USER' || this.userRole == 'SENIOR UW') && this.businessSource == "DIRECT") {
                        Swal.fire('The Additional Info has been requested for the Quotation Number: ' + this.quoteNumber);
                    } else {
                        Swal.fire('Quotation Number: ' + this.quoteNumber + ' has been referred to our expert team of UWs for review.');
                    }

                    this._route.navigate(['home/referalquote']);
                    // this.getQuotePlan('');	
                    // this.referalModel = false;           
                }

            }

        });
    }

    //------------------------------------------- UPLOAD ADDITIONAL DOCUMENTS ---------------------------------//
    uploadAdditionalDoc(event) {

        this.additionalDoc = true;

        this.additionalDocFile = [];
        for (var i = 0; i < event.target.files.length; i++) {

            const formData = new FormData();
            formData.append('file', event.target.files[i]);
            formData.append('stage', 'QUOTE_ADDINFO');
            formData.append('quotation_number', this.quoteNumber);

            this.motorQuoteService.uploadMultipleDocuments(formData).subscribe(res => {

                let updateMemResponse = res;
                this.document_data = updateMemResponse.Document_data;


                this.hideImages = true;

                if (updateMemResponse.res_code == 1) {
                    let fileType = updateMemResponse.File.split(".");
                    fileType = fileType[fileType.length - 1];
                    fileType = fileType == "pdf" ? "PDF" : "IMG";


                    this.additionalDocFile.push({
                        "file": updateMemResponse.FileDir,
                        "fileType": fileType,
                        'file_name': 'Additional_Doc',
                        'file_dir': updateMemResponse.FileDir,
                        'docName': updateMemResponse.File,
                    });

                    this.tempAdditionalDoc = this.additionalDocFile;

                    this.additionalDoc = false;

                }
                if (updateMemResponse.response_code == 5) {

                    this.additionalDoc = false;
                    Swal.fire("Please select valid file format.", "only .pdf file formats allowed.", 'error');

                }

                if (updateMemResponse.response_code == 6) {

                    this.additionalDoc = false;
                    Swal.fire(updateMemResponse.response_status);
                }

            });
        }
    }

    // ------------------------------------------Check Partner Credit Limit--------------------------------------------
    async checkPartnerCreditLimit() {
        //Added by Anju for Partner Status Check & Credit Limit
        this.selectedPartnerId = this.smeQuoteDetails.value.partner;
        this.selectedBranchId = this.smeQuoteDetails.value.branch.Id
        // let result= this.smequoteService.checkPartnerCreditLimit("Property All Risk",this.sectionpremium_PAR,this.selectedPartnerId,this.selectedBranchId);
        // let data = JSON.stringify(result)
        // console.log(result);
        // this.checkcreditLimitArray.push({status:result['cl_status']});

        if (this.sectionpremium_PL[0] != 0) {

            let result = await this.smequoteService.checkPartnerCreditLimit("Property All Risk", this.sectionpremium_CAR.reduce((accumulator, currentValue) => accumulator + currentValue, 0), this.selectedPartnerId, this.selectedBranchId);
            let data = JSON.stringify(result)
            console.log(result);
            this.checkcreditLimitArray.push({
                status: result['cl_status']
            })
        }
        if (this.sectionpremium_Money[0] != 0) {

            let result = await this.smequoteService.checkPartnerCreditLimit("Money", this.sectionpremium_Money.reduce((accumulator, currentValue) => accumulator + currentValue, 0), this.selectedPartnerId, this.selectedBranchId);
            let data = JSON.stringify(result)
            console.log(result);
            this.checkcreditLimitArray.push({
                status: result['cl_status']
            })

        }
        if (this.sectionpremium_PL[0] != 0) {

            let result = await this.smequoteService.checkPartnerCreditLimit("Public Liability", this.sectionpremium_PL.reduce((accumulator, currentValue) => accumulator + currentValue, 0), this.selectedPartnerId, this.selectedBranchId);
            let data = JSON.stringify(result)
            console.log(result);
            this.checkcreditLimitArray.push({
                status: result['cl_status']
            })
        }
     

        console.log('checkcreditLimitArray:', JSON.stringify(this.checkcreditLimitArray))
        const _CLStatus = this.checkcreditLimitArray.every((x) => x.status == "1");
        if (_CLStatus) {
            //new API call changes for checking credit Days- shuhaib
            //let res_credit=await this.smequoteService.checkPartnerCreditDays(this.selectedPartnerId);
            //console.log('checkPartnerCreditDays response for selectedPartnerId: '+this.selectedPartnerId,JSON.stringify(res_credit));
            // if(res_credit['creditDays']>0){
            this.lmt_days = _CLStatus;
            // }
            // else{
            //Swal.fire('Credit limit expired','Partner does not have sufficient Credit Days','error');
            // }
        } else {
            console.log('credit limit amount is exceeded')
            Swal.fire('Credit limit exceeded', 'Partner does not have sufficient Credit limit', 'error');
        }

        // this.checkcreditLimitArray.forEach((element,index)=>{
        //   console.log( this.checkcreditLimitArray[index])
        //   if(this.chechfor == true){
        //     if(this.checkcreditLimitArray[index].status == "100010"){
        //       // alert(1)
        //       this.lmt_days =false;
        //       return

        //     }

        //   }else{
        //     this.chechfor =false;
        //   }

        //   console.log(  this.lmt_days)


        // })

    }
    
    selectionChange(stepper: any) {
        this.locations.controls.forEach((x, i) => {
            if (this.locations.at(i).value.insuringProperty.label == 'Yes') {
                this.is_buildingSelected[i] = true;
            } else {
                this.is_buildingSelected[i] = false;
                this.benefitData[i].forEach((element, index) => {
                    if (element.BenefitName == 'On Building/Premises including Fixtures and Fittings') {
                        element.DefaultSumCovered = 0;
                    }
                })

            }
        })
        console.log(this.is_buildingSelected)

    }
    openMap() {
        const factory = this.resolver.resolveComponentFactory(GeoLocationComponent);
        const modalComponentRef = this.modalContainer.createComponent(factory);
        modalComponentRef.instance.closeModalEvent.subscribe(() => {
            modalComponentRef.destroy();
        });
    }
    riskIntheMall(i) {
        this.riskInMall[i] = this.locations.at(i).value.riskSelect == 'Y' ? true : false;

        if (!this.riskInMall[i]) {
            this.locations.at(i).get('emirateMall').setValidators(null);
            this.locations.at(i).get('emirateMall').setValue('');
            this.locations.at(i).get('emirateMall').updateValueAndValidity();
        } else if (this.riskInMall[i]) {
            this.locations.at(i).get('emirateMall').setValidators([Validators.required]);
            this.locations.at(i).get('emirateMall').updateValueAndValidity();
        }
    }

    //shuhaib changes for IA License and Trade License expiry check 13102023

    public getBrokerLicenseDetails(): Promise < boolean > {
        return new Promise(resolve => {
            let licenseValid: boolean = false;
            this.issuepolicyService.getBrokerLicenseDetails(this.smeQuoteDetails.value.partner, this.smeQuoteDetails.value.branch.Id).subscribe(res => {
                let _reponse = res;
                console.log('getBrokerLicenseDetails', JSON.stringify(res));
                if (_reponse.response_code == "1") {
                    if (!_reponse.getBrokerLicenseDetails[0].PTY_IA_LIC_VALID_TO_DT) {
                        Swal.fire("Your IA License is not updated in the system. Please contact your relationship manager as soon as possible to avoid inconvenience.", "error");
                    } else if (!_reponse.getBrokerLicenseDetails[0].PTY_BRK_LIC_VALID_TO_DT) {
                        Swal.fire("Your Trade License is not updated in the system. Please contact your relationship manager as soon as possible to avoid inconvenience.", "error");
                    } else {
                        var iaExpDate = new Date(_reponse.getBrokerLicenseDetails[0].PTY_IA_LIC_VALID_TO_DT);
                        var tdExpDate = new Date(_reponse.getBrokerLicenseDetails[0].PTY_BRK_LIC_VALID_TO_DT);
                        var currentDate = new Date();
                        if (iaExpDate < currentDate) {
                            Swal.fire("You are not authorized.  Please contact relationship manager.  Possible Reason. IA LICENSE EXPIRED.", "Sorry for the inconvenience caused", "error");
                        } else if (tdExpDate < currentDate) {
                            Swal.fire("You are not authorized.  Please contact relationship manager.  Possible Reason. TRADE LICENSE EXPIRED.", "Sorry for the inconvenience caused", "error");
                        } else {
                            licenseValid = true;
                        }
                    }
                } else {
                    Swal.fire("Something went wrong!. Please contact your relationship manager as soon as possible to avoid inconvenience.", "error");
                }
                resolve(licenseValid);
            })

        })
    }
    async GetInitiatedPolicyDetails(quotationNumber) {
        this.smequoteService.GetInitiatedPolicyDetails(quotationNumber, this.smeQuoteDetails.value.partner).subscribe(
            result => {
                debugger;
                this.IntitatedPolicyResult = result.data;
                this.policyNumber = result.data[0].PolicyNumber;
                this.initiatedPolDocs = result.docs;
                this.totalbasepremium = result.data[0].BasePremWithLoading.replace(/,/g, "");
                this.Vat_Amount = result.data[0].ValueAddedTax.replace(/,/g, "");
                this.policyFee = result.data[0].PolicyFees;
                this.loadingAmount = result.data[0].PremiumLoading;
                this.discountAmount = result.data[0].PremiumDiscount
                this.totalPremium = result.data[0].TotalContribution.replace(/,/g, "");
                (async () => {
                    for (let i = 0; i < this.IntitatedPolicyResult.length; i++) {
                        const element = this.IntitatedPolicyResult[i];

                        // Delay each iteration by 5 seconds
                        await new Promise((resolve) => setTimeout(resolve, 4000));

                        console.log(this.additionalDetailForm);
                        console.log(this.additionalDetails.at(i));

                        this.additionalDetails.at(i).get('contactperson').setValue(element.ContactPerson);
                        // this.additionalDetails.at(i).get('contactperson').setValue(element.EmailAddress);
                        // this.additionalDetails.at(i).get('mortgagee').setValue(element.MortgageeText);
                        this.additionalDetails.at(i).get('tradeLicNumber').setValue(element.RegistrationNumber);
                        this.additionalDetails.at(i).get('trnNo').setValue(element.TRNNumber);
                        this.additionalDetails.at(i).get('poboxNo').setValue(element.POBox);
                        this.additionalDetails.at(i).get('phoneNumber').setValue(element.PhoneNumber);
                        this.additionalDetails.at(i).get('companyAddress').setValue(element.RiskLocation);
                        this.additionalDetails.at(i).get('mobNo').setValue(element.MobileNumber);
                        this.additionalDetails.at(i).get('email').setValue(element.EmailAddress);
                        this.additionalDetails.at(i).get('trnNo').setValue(element.TRNNumber);
                        // this.additionalDetails.at(i).get('assignmentValue').setValue(null);

                        if (this.initiatedPolDocs.filter((d) => d.DocType === 'No VAT Declaration Letter').length > 0) {
                            this.additionalDetailForm.get('vatRegcheck').setValue(this.optionyesNo[0]);

                        } else {
                            this.additionalDetailForm.get('vatRegcheck').setValue(this.optionyesNo[1]);

                        }

                        if (result.data[i].MortgageeText != "0") {
                            this.additionalDetails.at(i).get('mortgageecheck').setValue(this.optionyesNo[0]);
                            console.log("Mortgage Yes", this.additionalDetails.at(i).get('mortgageecheck').value)
                            //this.additionalDetails.at(i).get('mortgagee').setValue(element.MortgageeText);
                            let mortgagebank = element.MortgageeText
                            var mortgageIndex = this.bankDetail.findIndex((obj, k) => {

                                return obj.InstituteName == mortgagebank;
                            });
                            this.additionalDetails.at(i).get('mortgagee').setValue(this.bankDetail[mortgageIndex]);
                            const assignmentValueControl = this.additionalDetails.at(i).get('assignmentValue');
                            console.log(assignmentValueControl)
                            assignmentValueControl.setAsyncValidators(null);
                            this.additionalDetails.at(i).get('assignmentValue').setValue(element.AssignmentValue);

                            this.checkValidation(i);

                        } else {
                            this.additionalDetails.at(i).get('mortgageecheck').setValue(this.optionyesNo[1]);
                            console.log("Mortgage No", this.additionalDetails.at(i).get('mortgageecheck').value)
                            const assignmentValueControl = this.additionalDetails.at(i).get('assignmentValue');
                            console.log(assignmentValueControl)
                            assignmentValueControl.setAsyncValidators(null);
                            // this.additionalDetails.at(i).get('assignmentValue').setValue(null);
                            // this.additionalDetails.at(i).get('mortgagee').setValue(null);

                            this.checkValidation(i);

                        }

                        // Fix freezzone value
                        this.additionalDetails.at(i).get('freezzone').setValue(this.freezzone[0]);
                    }
                })();

                // this.IntitatedPolicyResult.forEach((element,i) => {
                //  console.log(this.additionalDetailForm);
                //  console.log(this.additionalDetails.at(i))
                //   this.additionalDetails.at(i).get('contactperson').setValue(element.ContactPerson);
                //   // this.additionalDetails.at(i).get('contactperson').setValue(element.EmailAddress);
                //   this.additionalDetails.at(i).get('mortgagee').setValue(element.MortgageeText);
                //   this.additionalDetails.at(i).get('tradeLicNumber').setValue(element.RegistrationNumber);
                //   this.additionalDetails.at(i).get('trnNo').setValue(element.TRNNumber);
                //   this.additionalDetails.at(i).get('poboxNo').setValue(element.POBox);
                //   this.additionalDetails.at(i).get('phoneNumber').setValue(element.PhoneNumber);
                //   this.additionalDetails.at(i).get('companyAddress').setValue(element.RiskLocation);
                //   this.additionalDetails.at(i).get('mobNo').setValue(element.MobileNumber);
                //   this.additionalDetails.at(i).get('email').setValue(element.EmailAddress);
                //   this.additionalDetails.at(i).get('trnNo').setValue(element.TRNNumber);
                //   this.additionalDetails.at(i).get('assignmentValue').setValue(null);
                //   if(this.initiatedPolDocs.filter(d=>d.DocType=='No VAT Declaration Letter').length>0){
                //     this.additionalDetailForm.get('vatRegcheck').setValue(this.optionyesNo[0])
                //   }
                //   else{
                //     this.additionalDetailForm.get('vatRegcheck').setValue(this.optionyesNo[1])
                //   }
                //   if(result.data[i].MortgageeText.length>0){
                //     this.additionalDetails.at(i).get('mortgageecheck').setValue(this.optionyesNo[0])
                //   }
                //   else{
                //     this.additionalDetails.at(i).get('mortgageecheck').setValue(this.optionyesNo[1])
                //   }
                //   //need to fix freezzone value
                //   this.additionalDetails.at(i).get('freezzone').setValue(this.freezzone[0])
                // });


            })
        this.additionalDetails.controls.map((x, i) => {
            this.checkValidation(i)
            this.vatCheckValidation(0)
        })
        //Need to modify the below code -shuhaib
        // let creditLimit:any= await this.smequoteService.checkPartnerCreditLimit("7",this.sectionpremium_Money,this.selectedPartnerId,this.selectedBranchId);
        // debugger;
        //   this.lmt_days=creditLimit.cl_status=='1'?true:false;

        // this.getQuotation('')
        if (this.globalService.flag) {
            this.checkPartnerCreditLimit() //Remove on account option as per new regulation
        }

        //this.lmt_days=true;
        console.log(this.additionalDetails)

    }
    issueInitiatedpolicy(type) {

        if (!this.additionalDetails.controls.every(x => x.value.email)) {

            // this.additionalDetails.markAllAsTouched();
            //  this.additionalDetails.updateValueAndValidity();
            Swal.fire("", "Please fill all the mandatory data", 'error');
            return;

        } else if (this.accept_terms == false) {
            Swal.fire("", "Please Select Terms And Conditions", 'error');
            return;
        } else if (this.accept_disclaimer == false) {
            Swal.fire("", "Please accept Disclaimer", 'error');
            return;
        }
        this.issuepolicyLoader = this.globalService.spinnerShow();
        let savePolicy = []

        this.additionalDetailForm.value.additionalDetails.map((x, i) => {
            savePolicy.push({
                CompanyName: this.smeQuoteDetails.value.businessName.replace(this.characterToReplace, this.replacementCharacter),
                ContactPerson: x.contactperson,
                MortgageeText: x.mortgagee,
                AssignmentValue: x.assignmentValue,
                RegistrationNumber: x.tradeLicNumber,
                TRNNumber: x.trnNo,
                RiskLocation: x.companyAddress,
                POBox: x.poboxNo,
                PhoneNumber: x.phoneNumber,
                MobileNumber: x.mobNo,
                EmailAddress: x.email,
                FreeZone: x.freezzone.value,
                CoverStartDate: this.convertDate(this.additionalDetailForm.value.CoverStartDate),
                PartnerId: this.smeQuoteDetails.value.partner,
                UserId: this.userId,
                FixedPlanContribution: this.basePremium[i],
                FixedPlanId: this.planId,
                ServiceTax: this.serviceTax,
                ServiceTaxRate: 0,
                policyFee: this.policyFee,
                TotalContribution: this.totalPremium,
                VATAmount: this.Vat_Amount,
                VATTaxRate: 5,
                PremLoading: this.loadingAmount,
                PremLoadingRate: this.loadingby,
                PremDiscount: this.discountAmount,
                PremDiscountRate: this.discountby,
                ProductCode: this.productCode,
                QuotationNumber: this.quoteNumber,
                PlanId: this.planId,
                CurrencyCode: 'AED',
                source: 'B2B',
                AddressLatitude: this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[0].trim().slice(0, 19) : '',
                AddressLongitude: this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[1].trim().slice(0, 19) : '',
                PaymentType: type

            })

        })
        // let savePolicy=[{
        //   CompanyName:this.additionalDetailForm.value.entityName.replace(this.characterToReplace, this.replacementCharacter),
        //   ContactPerson:this.additionalDetailForm.value.contactperson,
        //   MortgageeText:this.additionalDetailForm.value.mortgagee
        //   ? this.additionalDetailForm.value.mortgagee
        //   : {
        //       "Id": 0,
        //       "InstituteName": "Not Mortgaged",
        //       "InstituteCode": "NTMORT",
        //       "CRS_Bank_Map_Code": "000"
        //   },
        //   RegistrationNumber:this.additionalDetailForm.value.tradeLicNumber,
        //   TRNNumber:this.additionalDetailForm.value.trnNo,
        //   RiskLocation:this.additionalDetailForm.value.companyAddress,
        //   POBox:this.additionalDetailForm.value.poboxNo,
        //   PhoneNumber:this.additionalDetailForm.value.phoneNumber,
        //   MobileNumber:this.additionalDetailForm.value.mobNo,
        //   EmailAddress:this.additionalDetailForm.value.email,
        //   FreeZone:this.additionalDetailForm.value.freezzone.value,
        //   CoverStartDate:this.convertDate(this.smeQuoteDetails.value.startDate),
        //   PartnerId:this.smeQuoteDetails.value.partner,
        //   UserId:this.userId,
        //   ProductCode: this.productCode,
        //   QuotationNumber:this.quoteNumber,
        //   PlanId:this.planId,
        //   CurrencyCode:'AED',
        //   source : 'B2B' ,
        //   AddressLatitude :this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[0].trim().slice(0, 19) : '',
        //  AddressLongitude :this.addressLocationCords.includes(',') ? this.addressLocationCords.split(',')[1].trim().slice(0, 19) : '',
        //  Type:type
        // }]
        //Added by Anju for party status active check on Issue Policy/Pay Now/Send Payment Link
        this.selectedPartnerId = this.smeQuoteDetails.value.partner;
        this.selectedBranchId = this.smeQuoteDetails.value.branch.Id;
        console.log('calling smequoteService.smesavePolicy savePolicy:' + JSON.stringify(savePolicy))
        console.log('calling smequoteService.smesavePolicy type:' + type)
        this.smequoteService.checkPartner_CreditLimit("Property All Risk", 0, this.selectedPartnerId, this.selectedBranchId).subscribe(response => {
            if (response.cl_status == '200012') {
                Swal.fire('Party is not Active.');
                this.issuepolicyLoader = this.globalService.spinnerHide();
            } else {
                if (type == 1) {
                    localStorage.removeItem('Payment_Order_ID');
                    localStorage.removeItem('Payment_Order_Tokan');
                    localStorage.removeItem('Payment_Quotation_Number');
                    localStorage.removeItem('Payment_Quotation_ID');
                    this.smequoteService.UpdateInitiatedSMEPolicy(savePolicy).subscribe(res => {
                        if (res.res_code == 1) {
                            this.policyNumber = res.policy_details[0].PolicyNumber;
                            this.getCreditDebitNote();
                            this.issuepolicyLoader = this.globalService.spinnerHide();
                            this._route.navigateByUrl("sme/thankyou/" + this.policyNumber + '/' + this.quoteNumber);
                        }
                    });
                }
                if (type == 2) {
                    this.smequoteService.UpdateInitiatedSMEPolicy(savePolicy).subscribe(res => {
                        this.policyNumber = this.policyNumber;
                        // if(res.res_code == 1){
                        let return_url = "http://localhost:4200/dashboard";
                        let site_url = "http://localhost:4200/" + this._route.url;
                        this.travelInsuranceService.paymentAuth(this.quoteNumber, site_url, return_url, 'SM', this.partnerID, this.policyNumber, 'SHIELD', 'B2B').subscribe(res => { //Added by Anju for SME Payment gateway revamp
                            debugger;
                            if (res.status == 'Failed') {
                                Swal.fire(res.res_msg);
                                this.issuepolicyLoader = this.globalService.spinnerHide();

                                return false;
                            } else if (res.status == 'Success') {

                                // this.policyLoader = this.globalService.spinnerHide();
                                localStorage.setItem('Payment_Order_ID', res.data.tran_ref);
                                localStorage.setItem('Payment_Order_Tokan', res.data.token);
                                localStorage.setItem('Payment_Quotation_Number', this.quoteNumber);
                                localStorage.setItem('Payment_Quotation_ID', this.quoteId);
                                window.location.href = res.data.redirect_url;
                                // window.open(res.result.redirect_url, '_blank');


                            }

                        })
                        //}
                    })

                }
                if (type == 3) {
                    this.smequoteService.UpdateInitiatedSMEPolicy(savePolicy).subscribe(res => {
                        this.motorQuoteService.sendPaymentLink(this.quoteNumber, 'SM', this.additionalDetailForm.value.email, 'B2B', '', this.smeQuoteDetails.value.partner).subscribe(res => {

                            let payRes = res;

                            if (payRes.res_code == 1) {

                                Swal.fire('', 'Payment link has been sent to customer for the reference no. ' + this.quoteNumber, 'success');

                                this._route.navigate(['sme/products']);

                            }
                            // this.showLoader.Quotation = false;
                        });
                    })
                }
            }
        });
    }

    checkDirectSalesAgent() {
        this.smequoteService.checkDirectSalesAgent(this.partnerID).subscribe(res => {
            let response = res;

            if (response.directSalesAgent.directSalesAgent == 'Y') {
                this.isDirectSalesAgent = true;
                this.disabled = false;
            }
        });
    }
    //getMortgagelist
    getMortgagelist() {

        this.motorQuoteService.getBankDetail().subscribe((res) => {
            this.bankDetailres = res.bankdetailsData;
            //remove the not mortgage value from the list
            this.bankDetail = this.bankDetailres.slice(1, this.bankDetailres.length);
            console.log("BankList", this.bankDetail)
            //this.additionalDetails.get('mortgagee').setValue(this.bankDetail[0]);
            ///this.filteredBank.next(this.bankDetail.slice());
        });

    }

    isRequiredMarker(i, controlName: string): boolean {
        // this.additionalDetails.at(i).get(controlName).setValidators(null);
        // this.additionalDetails.at(i).get(controlName).updateValueAndValidity();
        const control = this.additionalDetails.at(i).get(controlName).validator; // commented now
        return control != null ? true : false // commented now

    }
    isRequiredMarkerforLocationForm(i, controlName: string): boolean {
        // this.additionalDetails.at(i).get(controlName).setValidators(null);
        // this.additionalDetails.at(i).get(controlName).updateValueAndValidity();
        const control = this.locations.at(i).get(controlName).validator; // commented now
        return control != null ? true : false // commented now

    }


    CheckValueLimit(i, val) {
        const filteredValue = val.replace(/[^0-9]/g, ''); // Allow only numeric characters

        console.log(this.totalcar[i], this.pesp[i])
        this.allowedLimit[i] = this.cv[i] + this.uv[i];
        if (Number(filteredValue) > Number(this.allowedLimit[i])) {
            Swal.fire('', 'Assignment Value cannot be greater than Property Sum Insured', 'error');
            this.additionalDetails.at(i).get('assignmentValue').setValue(null);
            this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity();
        } else {
            this.additionalDetails.at(i).get('assignmentValue').setValue(filteredValue);
            this.additionalDetails.at(i).get('assignmentValue').updateValueAndValidity();
        }


    }
    onInput(i, event: any) {
        const inputValue = event.target.value;

    }

    CheckReferralConditions() {
        if (this.quoteStatus != 'REFERRED' && this.quoteStatus != 'REFAPPROVED' && this.quoteStatus != 'ADDITIONALINFO') {
            console.log(this.refReason)
            this.refReason[0] = ''
            if (this.isReferral == 3) {
                this.refReason[0] = this.refReason[0] + this.referalRes + ";\n";
                this.quoteLoader = this.globalService.spinnerHide();
                this.isToBeReferred = true;
            }
            // if(this.smeQuoteDetails.value.claimHistory.Id == '1'){
            //   if(this.policyType == "RENEWAL" || this.quoteStatus == 'RENQUOTE'){
            //   this.quoteLoader=this.globalService.spinnerHide();
            //   this.refferalButton =false;
            //   }else{
            //     this.refReason[0] = this.refReason[0] + "Claim History Selected as Yes" + ";\n";
            //     this.quoteLoader=this.globalService.spinnerHide();
            //     this.isToBeReferred = true;
            //   }
            // }
            // if(this.IsSameBusiness)
            // {
            //     this.refReason[0] = this.refReason[0] + "Business Name is Already Insured "+this.smeQuoteDetails.value.businessName + ";\n";
            //     this.quoteLoader=this.globalService.spinnerHide();
            //     this.isToBeReferred = true;
            // }
            this.locations.controls.forEach((x, i) => {
                console.log(this.refReason)
                if (i >= 1) {
                    this.refReason[i] = ''
                }
                console.log(this.isReferral);
                this.quotationloader = this.globalService.spinnerHide();
                console.log(this.claimCount);
                console.log(this.claimAmount);
                console.log(this.expiringPremium);
                if (this.claimCount > '3') {
                    this.refReason[i] = this.refReason[i] + "The pervious claim count is" + this.claimCount;
                    ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }
                this.claimRatio = (this.claimAmount / this.expiringPremium) * 100;
                console.log(this.claimRatio);
                if (this.claimRatio > 150) {
                    this.refReason[i] = this.refReason + "The gross loss ratio is more than 150%the gross loss ratio is more than 150%" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.claimCount > '3') {
                    this.refReason[i] = this.refReason[i] + "The pervious claim count is" + this.claimCount + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                console.log(this.locations.at(i).value)

                if (this.locations.at(i).value.emirateMall && this.locations.at(i).value.MallName === 'Others') {
                    this.refReason[i] = this.refReason + this.locations.at(i).value.businessPremises.BusinessPremise + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.upliftref == 1) {
                    this.refReason[i] = "Uplift More than 10% of CV" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.cvref == 1) {
                    this.refReason[i] = "Contract Value more than 40M" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.pespref == 1) {
                    this.refReason[i] = "PESP More Than 5M" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.cpmref == 1) {
                    this.refReason[i] = "CPM More than 500K" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.tfref == 1) {
                    this.refReason[i] = "Temperory Facility more than 500K" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

                if (this.drref == 1) {
                    this.refReason[i] = "Debris Removal more than 500k" + ";\n";
                    this.quoteLoader = this.globalService.spinnerHide();
                    this.isToBeReferred = true;
                }

            })
        }
        console.log(this.refReason)
        return this.isToBeReferred


    }

    updateSumInsured(item, i, locationIndex, sectionIndex) {

        this.totalSumInsured1[locationIndex] = Number(this.cv[locationIndex] || 0) + Number(this.uv[locationIndex] || 0) + Number(this.pesp[locationIndex] || 0) + Number(this.dr[locationIndex] || 0) + Number(this.cpm[locationIndex] || 0);
        this.benefitData[locationIndex].sections[sectionIndex].covers[i].DefaultSumCovered = this.totalSumInsured1[locationIndex].toString();
        this.cdr.detectChanges();
        this.premiumCalucation();

    }



    viewPlanBenefit(frame) {
        frame.show()
    }



  
    getLocationFormAtIndex(index: number): FormGroup {
        const locations = this.locationForm.get('locations') as FormArray;
        return locations.at(index) as FormGroup;
    }
    openModal(subArray, index): void {
        
        this.businessPackageModel = true;
        this.currentSubArray = subArray;
        this.currentIndex = index;
        console.log(subArray.employeeType)
        debugger;
    }
    closeModel() {
        this.businessPackageModel = false;
    }


    assignValues() {
        this.BusinessEntityList.map(value => {
            console.log("Single Business Value", value.BusinessEntityName);
            this.options.push(value.BusinessEntityName)
        })
    }

    
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    onBusinessEntitySelection(selectedValue: string) {

        const isValid = this.filteredOptionsList.some(
            (option) => option.BusinessEntityName === selectedValue
        );

        if (isValid) {
            console.log('Selected value is from the filtered options:', selectedValue);
        } else {
            console.log('Selected value is not from the filtered options:', selectedValue);
        }
        if (isValid != null) {
            this.IsSameBusiness = true
        } else {
            this.IsSameBusiness = false
        }
    }


    addCondition() {
        console.log(this.conditions); // Check if condition.productCode has the right value
        console.log(this.IIRISCodes);
        this.conditions.push({
            conditionType: '',
            description: '',
            productCode: ''
        });
    }


    removeCondition(index: number) {
        this.conditions.splice(index, 1);
    }

    saveAdditionlConditions() {
        this.smequoteService.saveAdditionalConditions(this.conditions, this.quoteNumber).subscribe(res => {
            let response = res;

            if (response.res_code == 1) {
                Swal.fire('Data Saved Successfully', 'Your SME quotation has been saved successfully.', 'success');
                this.isConditionModelOpen = false;

            }
        });
    }
    openAdditionalConditionModal(): void {
        this.isConditionModelOpen = true; // Open the modal
    }

    
    recalculatePremiums(): void {

        this.totalbasepremium = 0;

        this.loadingAmount = 0;
        this.discountAmount = 0;
        let totalsectionBasePremium = 0;
        this.benefitData.forEach((location, locindex) => {
            this.locationSumInsured = 0
            this.locationPremium = 0
            totalsectionBasePremium = 0
            location.sections.forEach(group => {
                let totalSumCovered = 0;
                let sectionBasePremium = 0;

                let selectedCovers = [];

                // Step 1: Calculate base premium for each checked cover
                group.covers.forEach(cover => {

                    let rawSum = typeof cover.DefaultSumCovered === 'string' ?
                        parseFloat(cover.DefaultSumCovered.replace(/,/g, '')) :
                        +cover.DefaultSumCovered;

                    if(this.enableCoverStartDateModify || this.quoteStatus == 'REFAPPROVED')
                    {
                        // do nothing
                    }
                    else if (this.quoteStatus != 'REFAPPROVED' && rawSum > Number(cover.BenefitSI) && !this.enableCoverStartDateModify )
                    {
                            cover.DefaultSumCovered = cover.BenefitSI
                            Swal.fire('Invalid Sum Insured', cover.BenefitName + ',' + 'cannot be more than' + ' ' + (cover.BenefitSI).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","), 'error');
                            return;
                    }
                    else
                    {
                        // do nothing
                    }
                    // if (this.quoteStatus != 'REFAPPROVED')
                    // {
                    //     if ((rawSum > Number(cover.BenefitSI) &&   !this.enableCoverStartDateModify)) {
                            
                    //     }
                    // }

                    if (isNaN(rawSum)) rawSum = 0;

                    cover.DefaultSumCovered = rawSum.toLocaleString('en-US');
                    cover.checked = cover.checked && rawSum > 0;

                    if (!cover.checked) {
                        cover.DefaultSumCovered = 0;
                        cover.coverPremium = 0;

                        return;
                    }
                    // else
                    // {
                    //   cover.DefaultSumCovered = cover.SumCover;
                    // }

                    if(rawSum > 500000)
                    {
                        cover.Rate = 0.5
                      
                    }
                    
                    const basePremium = rawSum * (cover.Rate / 100);
                    cover._basePremium = +basePremium.toFixed(2); // Temporary store
                    sectionBasePremium += cover._basePremium;  
                    
                    totalSumCovered += rawSum;
                    cover.AdjustedBasePremium = 0
                    selectedCovers.push(cover);
                });

                // Step 2: Adjust cover base premiums if sectionBasePremium < minPremium
                const minPrem = group.minPremium || 0;
                const isAdjustNeeded = sectionBasePremium < minPrem && sectionBasePremium > 0;

                selectedCovers.forEach(cover => {
                    let adjustedBase = cover._basePremium;

                    // Adjust proportionally
                    if (isAdjustNeeded) {
                        adjustedBase = (cover._basePremium / sectionBasePremium) * minPrem;
                        adjustedBase = Math.round(adjustedBase * 100) / 100; // rounding issue
                    }
                    cover.AdjustedBasePremium = parseFloat(adjustedBase.toFixed(2))

                    // Step 3: Apply loading
                    if (cover.loadingType === 'Lamount') {
                        adjustedBase += +cover.LoadingAmount;
                    }

                    if (cover.loadingType === 'Lpercent') {
                        cover.LoadingPercentageAmount = this.roundToTwo(adjustedBase * (+cover.LoadingPercentage / 100))
                        adjustedBase += cover.LoadingPercentageAmount;
                    }



                    // Step 4: Apply discount
                    if (cover.discountType === 'Damount') {
                        adjustedBase -= +cover.DiscountAmount;
                    }

                    if (cover.discountType === 'Dpercent') {
                        cover.DiscountPercentageAmount = adjustedBase * (+cover.DiscountPercentage / 100)
                        adjustedBase -= adjustedBase * (+cover.DiscountPercentage / 100);
                    }

                    // Reset other values
                    if (cover.loadingType === 'Lamount') {
                        cover.LoadingPercentage = 0
                        cover.LoadingPercentageAmount = 0
                    } else if (cover.loadingType === 'Lpercent') {
                        cover.LoadingAmount = 0
                    } else {

                    }

                    if (cover.discountType === 'Damount') {
                        cover.DiscountPercentage = 0
                        cover.DiscountPercentageAmount = 0
                    } else if (cover.discountType === 'Dpercent') {
                        cover.DiscountAmount = 0
                    } else {

                    }

                    if (adjustedBase > 0) {
                        adjustedBase = Math.max(0, adjustedBase);
                        cover.coverPremium = +adjustedBase.toFixed(2);
                    }


                    if (adjustedBase < 0) {
                        console.log(locindex, cover.BenefitId, cover.BenefitName)
                        console.log("Negative Premium Value", adjustedBase)
                        Swal.fire("Negative Premium", "The calculated premium value is negative. Please check the inputs.", "error")
                        if (cover.discountType === 'Damount') {
                            cover.DiscountAmount = 0
                            adjustedBase = cover.AdjustedBasePremium
                            adjustedBase = Math.max(0, adjustedBase);
                            cover.coverPremium = +adjustedBase.toFixed(2);
                            cover.discountType = ''

                        } else if (cover.discountType == 'Dpercent') {
                            cover.DiscountPercentage = 0
                            cover.DiscountPercentageAmount = 0
                            adjustedBase = cover.AdjustedBasePremium
                            adjustedBase = Math.max(0, adjustedBase);
                            cover.coverPremium = +adjustedBase.toFixed(2);
                            cover.discountType = ''
                        } else {

                        }
                        return;
                    }



                    this.totalbasepremium += parseFloat(cover.AdjustedBasePremium)
                    totalsectionBasePremium += parseFloat(cover.AdjustedBasePremium)
                    this.loadingAmount += parseFloat(cover.LoadingAmount || 0) + parseFloat(cover.LoadingPercentageAmount || 0)
                    this.discountAmount += parseFloat(cover.DiscountAmount || 0) + parseFloat(cover.DiscountPercentageAmount || 0)

                    console.log(this.totalbasepremium, this.loadingAmount, this.discountAmount)
                });

                // Step 5: Final totals
                const finalSectionPremium = selectedCovers.reduce(
                    (sum, c) => sum + (c.coverPremium || 0),
                    0
                );

                group.sectionSumCovered = totalSumCovered;
                group.sectionPremium = +finalSectionPremium.toFixed(2);

                // Cleanup
                group.covers.forEach(c => delete c._basePremium);
                this.locationSumInsured += +group.sectionSumCovered
                this.locationPremium += group.sectionPremium
                console.log(this.locationSumInsured, this.locationPremium)
            });
            location.locationSumInsured = this.locationSumInsured
            location.locationPremium = this.locationPremium
            location.locationBasePremium = totalsectionBasePremium
        });

        this.totalPremium = this.getTotalPremium();
        this.totalsumCoveredAll = this.getTotalSumInsuredAllLocations()
        console.log("Total Section Premium", this.totalPremium)
    }


    getTotalPremium(): number {
        this.Vat_Amount = 0
        this.Vat_Amount += (this.totalbasepremium + this.loadingAmount + this.policyFee - this.discountAmount) * 0.05;

        return (this.totalbasepremium + this.Vat_Amount + this.policyFee + this.loadingAmount - this.discountAmount);
        this.benefitData.reduce((total, location) => {
            return total + location.sections.reduce((sum, section) => sum + (section.sectionPremium || 0), 0);
        }, 0);
    }

    getTotalSumInsuredAllLocations(): number {


        return this.benefitData.reduce((total, location) => {
            return total + location.sections.reduce((sum, section) => sum + (section.sectionSumCovered || 0), 0);
        }, 0);
    }
    

    // recalculatePremiums(): void {
    //         let premiumsummary = []
    //         //CPM rating
    //         this.locations.value.forEach((x,i) => {
    //             if(x.equipmentValue <=500000)
    //             {
    //                 let rate = 0.05/100
    //                 //premiumsummary.equipmentPremium = x.equipmentValue * rate
    //                 this.benefitData.locationSumInsured = this.locationSumInsured
    //                 this.benefitData.locationPremium = this.locationPremium
    //                 this.benefitData.locationBasePremium = totalsectionBasePremium
    //                 this.totalPremium +=  this.benefitData.locationSumInsured 
            
    //             }
    //             else
    //             {
    //                 let rate = 0.05/100
    //                // premiumsummary.equipmentPremium = x.equipmentValue * rate
    //                 this.benefitData.locationSumInsured = this.locationSumInsured
    //                 this.benefitData.locationPremium = this.locationPremium
    //                 this.benefitData.locationBasePremium = totalsectionBasePremium
    //                 this.totalPremium +=  this.benefitData.locationSumInsured 
    //             }
    //             if(this.totalPremium< 1000)
    //             {
    //                 this.totalPremium = 1000
    //             }
    //         });
    //        this.totalbasepremium = 0;
   
    //        this.loadingAmount = 0;
    //        this.discountAmount = 0;
    //        let totalsectionBasePremium = 0;
   
    //        this.totalPremium = this.getTotalPremium();
    //        this.totalsumCoveredAll = this.getTotalSumInsuredAllLocations()
    //        console.log("Total Section Premium", this.totalPremium)
    // }

    // getTotalPremium(): number {
    //     this.Vat_Amount = 0
    //     this.Vat_Amount += (this.totalbasepremium + this.loadingAmount + this.policyFee - this.discountAmount) * 0.05;

    //     return (this.totalbasepremium + this.Vat_Amount + this.policyFee + this.loadingAmount - this.discountAmount);
    //     this.benefitData.reduce((total, location: any) => {
    //         return total + location.sections.reduce((sum, section) => sum + (section.sectionPremium || 0), 0);
    //     }, 0);
    // }

    // getTotalSumInsuredAllLocations(): number {


    //     return this.benefitData.reduce((total, location: any) => {
    //         return total + location.sections.reduce((sum, section) => sum + (section.sectionSumCovered || 0), 0);
    //     }, 0);
    // }
   

    roundToTwo(num) {
        return Math.round(num * 100) / 100;
    }

    calculateLoading() {
        this.premiumCalucation()
    }

    restrictToNumbers(event): void {
    // Remove any non-numeric characters from the input value
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    }

    
  handleExcelUpload(input: any): void {
    const file = input.target.files[0];
    if (!file) return;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      this.populateFormWithExcelData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  }

  openFilePicker() {
  const fileInput = document.getElementById('excelFile') as HTMLInputElement;

  // Clear previous selection
  fileInput.value = '';

  // Open file dialog
  fileInput.click();
}

populateFormWithExcelData(data: any[]): void {
  this.locations.clear();
  this.errorMessages = [];

  data.forEach((row, index) => {
    const rowIndex = index + 2; // Excel header is row 1

    const requiredFields = [
      { key: 'Type of Equipment', label: 'Equipment Type' },
    //   { key: 'equipmentQuantity', label: 'Equipment Quantity' },
      { key: 'Year of Manufacturing', label: 'Equipment Year' },
      { key: 'Value of Equipment (AED)', label: 'Equipment Value' },
      { key: 'Make', label: 'Equipment Make' },
      { key: 'Model', label: 'Equipment Model' },
      { key: 'Chasis No./ Engine No./ Unique Reference No.', label: 'Equipment Serial No.' }
    ];

    const errors = requiredFields
      .filter(f => !row[f.key] || row[f.key].toString().trim() === '')
      .map(f => `Row ${rowIndex}: Missing value in '${f.label}'`);
console.log(row);
    // Get and clean equipment type string from Excel
    const equipmentTypeName = row['Type of Equipment'].toString().trim();

    // Map the Excel string to the actual dropdown object
    const matchedEquipmentType = this.equipmentTypeList.find(
      type => type.EquipmentTypeName.toLowerCase() === equipmentTypeName.toLowerCase()
    );

    if (!matchedEquipmentType) {
      errors.push(`Row ${rowIndex}: Invalid Equipment Type '${equipmentTypeName}'`);
    }

    if (errors.length > 0) {
      this.errorMessages.push(...errors);
    } else {
      this.locations.push(this.formBuilder.group({
        equipmentType: [matchedEquipmentType, Validators.required],
        //equipmentQuantity: [row['equipmentQuantity'], Validators.required],
        equipmentYear: [row['Year of Manufacturing'], Validators.required],
        equipmentValue: [row['Value of Equipment (AED)'], Validators.required],
        equipmentMake: [row['Make'], Validators.required],
        equipmentModel: [row['Model'], Validators.required],
        equipmentNo: [row['Chasis No./ Engine No./ Unique Reference No.'], Validators.required],
      }));
    }
  });
}



}
